/* @generated from adl module kachemedia.specsheet.artworkspec */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as kachemedia_specsheet_common from './common';

export interface Specifications_Components {
  kind: 'components';
  value: NamedAnnotated<ArtworkSpec>[];
}

/**
 * Placement Specifications
 */
export type Specifications = Specifications_Components;

export interface SpecificationsOpts {
  /**
   * Multiple named artwork specs or parts in the placement
   */
  components: NamedAnnotated<ArtworkSpec>[];
}

export function makeSpecifications<K extends keyof SpecificationsOpts>(kind: K, value: SpecificationsOpts[K]) { return {kind, value}; }

const Specifications_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement Specifications\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Multiple named artwork specs or parts in the placement\n"}],"serializedName":"components","default":{"kind":"nothing"},"name":"components","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"NamedAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"ArtworkSpec"}},"parameters":[]}]}]}}]}},"name":"Specifications","version":{"kind":"nothing"}}};

export const snSpecifications: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Specifications"};

export function texprSpecifications(): ADL.ATypeExpr<Specifications> {
  return {value : {typeRef : {kind: "reference", value : snSpecifications}, parameters : []}};
}

/**
 * Vector where each entry is optionally named and with optional notes metadata
 */
export type VectorNamedAnnotated<T> = NamedAnnotated<T>[];

const VectorNamedAnnotated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Vector where each entry is optionally named and with optional notes metadata\n"}],"type_":{"kind":"type_","value":{"typeParams":["T"],"typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"NamedAnnotated"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}]}}},"name":"VectorNamedAnnotated","version":{"kind":"nothing"}}};

export const snVectorNamedAnnotated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VectorNamedAnnotated"};

export function texprVectorNamedAnnotated<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<VectorNamedAnnotated<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "kachemedia.specsheet.artworkspec",name : "VectorNamedAnnotated"}}, parameters : [texprT.value]}};
}

/**
 * Vector where each entry has optional notes metadata
 */
export type VectorAnnotated<T> = Annotated<T>[];

const VectorAnnotated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Vector where each entry has optional notes metadata\n"}],"type_":{"kind":"type_","value":{"typeParams":["T"],"typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}]}}},"name":"VectorAnnotated","version":{"kind":"nothing"}}};

export const snVectorAnnotated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VectorAnnotated"};

export function texprVectorAnnotated<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<VectorAnnotated<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "kachemedia.specsheet.artworkspec",name : "VectorAnnotated"}}, parameters : [texprT.value]}};
}

export interface ArtworkSpec_DigitalStatic {
  kind: 'digitalStatic';
  value: DigitalStaticMedia;
}
export interface ArtworkSpec_Animated {
  kind: 'animated';
  value: AnimatedMedia;
}
export interface ArtworkSpec_Html5 {
  kind: 'html5';
  value: Html5Media;
}
export interface ArtworkSpec_Video {
  kind: 'video';
  value: Video;
}
export interface ArtworkSpec_Audio {
  kind: 'audio';
  value: Audio;
}
export interface ArtworkSpec_Copy {
  kind: 'copy';
  value: CopyMedia;
}
export interface ArtworkSpec_Newspaper {
  kind: 'newspaper';
  value: PrintNewspaper;
}
export interface ArtworkSpec_Magazine {
  kind: 'magazine';
  value: PrintMagazine;
}
export interface ArtworkSpec_PrintOOH {
  kind: 'printOOH';
  value: PrintOOH;
}

/**
 * Artwork Specification - one of a family of appropriate properties per media type
 */
export type ArtworkSpec = ArtworkSpec_DigitalStatic | ArtworkSpec_Animated | ArtworkSpec_Html5 | ArtworkSpec_Video | ArtworkSpec_Audio | ArtworkSpec_Copy | ArtworkSpec_Newspaper | ArtworkSpec_Magazine | ArtworkSpec_PrintOOH;

export interface ArtworkSpecOpts {
  digitalStatic: DigitalStaticMedia;
  animated: AnimatedMedia;
  html5: Html5Media;
  video: Video;
  audio: Audio;
  copy: CopyMedia;
  newspaper: PrintNewspaper;
  magazine: PrintMagazine;
  printOOH: PrintOOH;
}

export function makeArtworkSpec<K extends keyof ArtworkSpecOpts>(kind: K, value: ArtworkSpecOpts[K]) { return {kind, value}; }

const ArtworkSpec_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Artwork Specification - one of a family of appropriate properties per media type\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"digitalStatic","default":{"kind":"nothing"},"name":"digitalStatic","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalStaticMedia"}},"parameters":[]}},{"annotations":[],"serializedName":"animated","default":{"kind":"nothing"},"name":"animated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AnimatedMedia"}},"parameters":[]}},{"annotations":[],"serializedName":"html5","default":{"kind":"nothing"},"name":"html5","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Html5Media"}},"parameters":[]}},{"annotations":[],"serializedName":"video","default":{"kind":"nothing"},"name":"video","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Video"}},"parameters":[]}},{"annotations":[],"serializedName":"audio","default":{"kind":"nothing"},"name":"audio","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Audio"}},"parameters":[]}},{"annotations":[],"serializedName":"copy","default":{"kind":"nothing"},"name":"copy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"CopyMedia"}},"parameters":[]}},{"annotations":[],"serializedName":"newspaper","default":{"kind":"nothing"},"name":"newspaper","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintNewspaper"}},"parameters":[]}},{"annotations":[],"serializedName":"magazine","default":{"kind":"nothing"},"name":"magazine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintMagazine"}},"parameters":[]}},{"annotations":[],"serializedName":"printOOH","default":{"kind":"nothing"},"name":"printOOH","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintOOH"}},"parameters":[]}}]}},"name":"ArtworkSpec","version":{"kind":"nothing"}}};

export const snArtworkSpec: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"ArtworkSpec"};

export function texprArtworkSpec(): ADL.ATypeExpr<ArtworkSpec> {
  return {value : {typeRef : {kind: "reference", value : snArtworkSpec}, parameters : []}};
}

/**
 * A value - optionally with metadata
 */
export interface Annotated<T> {
  metadata: (Metadata|null);
  value: T;
}

export function makeAnnotated<T>(
  input: {
    metadata?: (Metadata|null),
    value: T,
  }
): Annotated<T> {
  return {
    metadata: input.metadata === undefined ? null : input.metadata,
    value: input.value,
  };
}

const Annotated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A value - optionally with metadata\n"}],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Add notes and images"}],"serializedName":"metadata","default":{"kind":"just","value":null},"name":"metadata","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Metadata"}},"parameters":[]}]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"Annotated","version":{"kind":"nothing"}}};

export const snAnnotated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Annotated"};

export function texprAnnotated<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<Annotated<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "kachemedia.specsheet.artworkspec",name : "Annotated"}}, parameters : [texprT.value]}};
}

/**
 * A value with an optional name and metadata
 */
export interface NamedAnnotated<T> {
  metadata: (Metadata|null);
  name: (string|null);
  value: T;
}

export function makeNamedAnnotated<T>(
  input: {
    metadata?: (Metadata|null),
    name?: (string|null),
    value: T,
  }
): NamedAnnotated<T> {
  return {
    metadata: input.metadata === undefined ? null : input.metadata,
    name: input.name === undefined ? null : input.name,
    value: input.value,
  };
}

const NamedAnnotated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A value with an optional name and metadata\n"}],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Add notes and images"}],"serializedName":"metadata","default":{"kind":"just","value":null},"name":"metadata","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Metadata"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"just","value":null},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"NamedAnnotated","version":{"kind":"nothing"}}};

export const snNamedAnnotated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"NamedAnnotated"};

export function texprNamedAnnotated<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<NamedAnnotated<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "kachemedia.specsheet.artworkspec",name : "NamedAnnotated"}}, parameters : [texprT.value]}};
}

export interface Metadata {
  /**
   * Displayed notes Notes on the field
   */
  notes: (kachemedia_specsheet_common.Notes|null);
  /**
   * Images relating to the field
   */
  images: kachemedia_specsheet_common.UrlResource[];
  /**
   * Internal author notes
   */
  authorNotes: AuthorNotes[];
}

export function makeMetadata(
  input: {
    notes?: (kachemedia_specsheet_common.Notes|null),
    images?: kachemedia_specsheet_common.UrlResource[],
    authorNotes?: AuthorNotes[],
  }
): Metadata {
  return {
    notes: input.notes === undefined ? null : input.notes,
    images: input.images === undefined ? [] : input.images,
    authorNotes: input.authorNotes === undefined ? [] : input.authorNotes,
  };
}

const Metadata_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Displayed notes Notes on the field\n"}],"serializedName":"notes","default":{"kind":"just","value":null},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Notes"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Images relating to the field\n"}],"serializedName":"images","default":{"kind":"just","value":[]},"name":"images","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.http","name":"OpenApiExclude"},"v2":true},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Internal author notes\n"}],"serializedName":"authorNotes","default":{"kind":"just","value":[]},"name":"authorNotes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AuthorNotes"}},"parameters":[]}]}}]}},"name":"Metadata","version":{"kind":"nothing"}}};

export const snMetadata: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Metadata"};

export function texprMetadata(): ADL.ATypeExpr<Metadata> {
  return {value : {typeRef : {kind: "reference", value : snMetadata}, parameters : []}};
}

export interface AuthorNotes {
  author: string;
  reason: AuthorNotesReason;
  notes: (kachemedia_specsheet_common.Notes|null);
}

export function makeAuthorNotes(
  input: {
    author?: string,
    reason?: AuthorNotesReason,
    notes?: (kachemedia_specsheet_common.Notes|null),
  }
): AuthorNotes {
  return {
    author: input.author === undefined ? "" : input.author,
    reason: input.reason === undefined ? {kind : "clarification"} : input.reason,
    notes: input.notes === undefined ? null : input.notes,
  };
}

const AuthorNotes_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"author","default":{"kind":"just","value":""},"name":"author","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"reason","default":{"kind":"just","value":"clarification"},"name":"reason","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AuthorNotesReason"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"just","value":null},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Notes"}},"parameters":[]}]}}]}},"name":"AuthorNotes","version":{"kind":"nothing"}}};

export const snAuthorNotes: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AuthorNotes"};

export function texprAuthorNotes(): ADL.ATypeExpr<AuthorNotes> {
  return {value : {typeRef : {kind: "reference", value : snAuthorNotes}, parameters : []}};
}

export interface AuthorNotesReason_Clarification {
  kind: 'clarification';
}
export interface AuthorNotesReason_Underspecified {
  kind: 'underspecified';
}
export interface AuthorNotesReason_Other_ {
  kind: 'other_';
  value: string;
}

export type AuthorNotesReason = AuthorNotesReason_Clarification | AuthorNotesReason_Underspecified | AuthorNotesReason_Other_;

export interface AuthorNotesReasonOpts {
  clarification: null;
  underspecified: null;
  other_: string;
}

export function makeAuthorNotesReason<K extends keyof AuthorNotesReasonOpts>(kind: K, value: AuthorNotesReasonOpts[K]) { return {kind, value}; }

const AuthorNotesReason_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"clarification","default":{"kind":"nothing"},"name":"clarification","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"More Specific Field Required"}],"serializedName":"underspecified","default":{"kind":"nothing"},"name":"underspecified","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"other_","default":{"kind":"nothing"},"name":"other_","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"AuthorNotesReason","version":{"kind":"nothing"}}};

export const snAuthorNotesReason: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AuthorNotesReason"};

export function texprAuthorNotesReason(): ADL.ATypeExpr<AuthorNotesReason> {
  return {value : {typeRef : {kind: "reference", value : snAuthorNotesReason}, parameters : []}};
}

export interface PrintResolution {
  amount: number;
  unit: PrintResolutionUnit;
}

export function makePrintResolution(
  input: {
    amount: number,
    unit: PrintResolutionUnit,
  }
): PrintResolution {
  return {
    amount: input.amount,
    unit: input.unit,
  };
}

const PrintResolution_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintResolutionUnit"}},"parameters":[]}}]}},"name":"PrintResolution","version":{"kind":"nothing"}}};

export const snPrintResolution: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintResolution"};

export function texprPrintResolution(): ADL.ATypeExpr<PrintResolution> {
  return {value : {typeRef : {kind: "reference", value : snPrintResolution}, parameters : []}};
}

export interface PrintResolutionUnit_DPI {
  kind: 'DPI';
}
export interface PrintResolutionUnit_LPI {
  kind: 'LPI';
}
export interface PrintResolutionUnit_Other {
  kind: 'other';
  value: string;
}

/**
 * Print Resolution
 */
export type PrintResolutionUnit = PrintResolutionUnit_DPI | PrintResolutionUnit_LPI | PrintResolutionUnit_Other;

export interface PrintResolutionUnitOpts {
  /**
   * dots per inch
   */
  DPI: null;
  /**
   * lines per inch
   */
  LPI: null;
  other: string;
}

export function makePrintResolutionUnit<K extends keyof PrintResolutionUnitOpts>(kind: K, value: PrintResolutionUnitOpts[K]) { return {kind, value}; }

const PrintResolutionUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Print Resolution\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"dots per inch\n"}],"serializedName":"DPI","default":{"kind":"nothing"},"name":"DPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"lines per inch\n"}],"serializedName":"LPI","default":{"kind":"nothing"},"name":"LPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"other","default":{"kind":"nothing"},"name":"other","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PrintResolutionUnit","version":{"kind":"nothing"}}};

export const snPrintResolutionUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintResolutionUnit"};

export function texprPrintResolutionUnit(): ADL.ATypeExpr<PrintResolutionUnit> {
  return {value : {typeRef : {kind: "reference", value : snPrintResolutionUnit}, parameters : []}};
}

export interface DigitalResolution {
  amount: number;
  unit: DigitalResolutionUnit;
}

export function makeDigitalResolution(
  input: {
    amount: number,
    unit: DigitalResolutionUnit,
  }
): DigitalResolution {
  return {
    amount: input.amount,
    unit: input.unit,
  };
}

const DigitalResolution_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalResolutionUnit"}},"parameters":[]}}]}},"name":"DigitalResolution","version":{"kind":"nothing"}}};

export const snDigitalResolution: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DigitalResolution"};

export function texprDigitalResolution(): ADL.ATypeExpr<DigitalResolution> {
  return {value : {typeRef : {kind: "reference", value : snDigitalResolution}, parameters : []}};
}

export interface DigitalResolutionUnit_DPI {
  kind: 'DPI';
}
export interface DigitalResolutionUnit_PPI {
  kind: 'PPI';
}
export interface DigitalResolutionUnit_Other {
  kind: 'other';
  value: string;
}

/**
 * Digital Resolution
 */
export type DigitalResolutionUnit = DigitalResolutionUnit_DPI | DigitalResolutionUnit_PPI | DigitalResolutionUnit_Other;

export interface DigitalResolutionUnitOpts {
  /**
   * dots per inch
   */
  DPI: null;
  /**
   * pixels per inch
   */
  PPI: null;
  other: string;
}

export function makeDigitalResolutionUnit<K extends keyof DigitalResolutionUnitOpts>(kind: K, value: DigitalResolutionUnitOpts[K]) { return {kind, value}; }

const DigitalResolutionUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Digital Resolution\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"dots per inch\n"}],"serializedName":"DPI","default":{"kind":"nothing"},"name":"DPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"pixels per inch\n"}],"serializedName":"PPI","default":{"kind":"nothing"},"name":"PPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"other","default":{"kind":"nothing"},"name":"other","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"DigitalResolutionUnit","version":{"kind":"nothing"}}};

export const snDigitalResolutionUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DigitalResolutionUnit"};

export function texprDigitalResolutionUnit(): ADL.ATypeExpr<DigitalResolutionUnit> {
  return {value : {typeRef : {kind: "reference", value : snDigitalResolutionUnit}, parameters : []}};
}

export interface DigitalStaticMedia {
  dimensions: Annotated<DigitalMediaDimensions>;
  maxFileSize: (Annotated<DataAmount>|null);
  safeZone: (Annotated<common.Unit>|null);
  DPI: (Annotated<number>|null);
  resolution: (Annotated<DigitalResolution>|null);
  aspectRatios: (Annotated<VideoAspectRatios>|null);
  color: (Annotated<DigitalColorSpace>|null);
  border: (Annotated<Border>|null);
  /**
   * Supported formats for static media
   */
  formats: Annotated<StaticMediaFormat>;
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makeDigitalStaticMedia(
  input: {
    dimensions: Annotated<DigitalMediaDimensions>,
    maxFileSize?: (Annotated<DataAmount>|null),
    safeZone?: (Annotated<common.Unit>|null),
    DPI?: (Annotated<number>|null),
    resolution?: (Annotated<DigitalResolution>|null),
    aspectRatios?: (Annotated<VideoAspectRatios>|null),
    color?: (Annotated<DigitalColorSpace>|null),
    border?: (Annotated<Border>|null),
    formats: Annotated<StaticMediaFormat>,
    attributes?: Attributes,
  }
): DigitalStaticMedia {
  return {
    dimensions: input.dimensions,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    safeZone: input.safeZone === undefined ? null : input.safeZone,
    DPI: input.DPI === undefined ? null : input.DPI,
    resolution: input.resolution === undefined ? null : input.resolution,
    aspectRatios: input.aspectRatios === undefined ? null : input.aspectRatios,
    color: input.color === undefined ? null : input.color,
    border: input.border === undefined ? null : input.border,
    formats: input.formats,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const DigitalStaticMedia_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dimensions","default":{"kind":"nothing"},"name":"dimensions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalMediaDimensions"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Safe Zone"}],"serializedName":"safeZone","default":{"kind":"just","value":null},"name":"safeZone","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.http","name":"OpenApiExclude"},"v2":true},{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution (DPI) (Deprecated)"}],"serializedName":"DPI","default":{"kind":"just","value":null},"name":"DPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution"}],"serializedName":"resolution","default":{"kind":"just","value":null},"name":"resolution","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalResolution"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Aspect Ratio"}],"serializedName":"aspectRatios","default":{"kind":"just","value":null},"name":"aspectRatios","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoAspectRatios"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Color Space"}],"serializedName":"color","default":{"kind":"just","value":null},"name":"color","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalColorSpace"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Border"}],"serializedName":"border","default":{"kind":"just","value":null},"name":"border","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Border"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported formats for static media\n"}],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"StaticMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"DigitalStaticMedia","version":{"kind":"nothing"}}};

export const snDigitalStaticMedia: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DigitalStaticMedia"};

export function texprDigitalStaticMedia(): ADL.ATypeExpr<DigitalStaticMedia> {
  return {value : {typeRef : {kind: "reference", value : snDigitalStaticMedia}, parameters : []}};
}

export type AdditionalPrintDimensions = VectorNamedAnnotated<PrintDimensions>;

const AdditionalPrintDimensions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorNamedAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}}},"name":"AdditionalPrintDimensions","version":{"kind":"nothing"}}};

export const snAdditionalPrintDimensions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AdditionalPrintDimensions"};

export function texprAdditionalPrintDimensions(): ADL.ATypeExpr<AdditionalPrintDimensions> {
  return {value : {typeRef : {kind: "reference", value : snAdditionalPrintDimensions}, parameters : []}};
}

export interface PrintDimension {
  value: number;
  unit: DimensionUnit;
}

export function makePrintDimension(
  input: {
    value: number,
    unit: DimensionUnit,
  }
): PrintDimension {
  return {
    value: input.value,
    unit: input.unit,
  };
}

const PrintDimension_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DimensionUnit"}},"parameters":[]}}]}},"name":"PrintDimension","version":{"kind":"nothing"}}};

export const snPrintDimension: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintDimension"};

export function texprPrintDimension(): ADL.ATypeExpr<PrintDimension> {
  return {value : {typeRef : {kind: "reference", value : snPrintDimension}, parameters : []}};
}

export interface PrintDimensions {
  height: PrintDimension;
  width: PrintDimension;
}

export function makePrintDimensions(
  input: {
    height: PrintDimension,
    width: PrintDimension,
  }
): PrintDimensions {
  return {
    height: input.height,
    width: input.width,
  };
}

const PrintDimensions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Height/Depth"}],"serializedName":"height","default":{"kind":"nothing"},"name":"height","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimension"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Width"}],"serializedName":"width","default":{"kind":"nothing"},"name":"width","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimension"}},"parameters":[]}}]}},"name":"PrintDimensions","version":{"kind":"nothing"}}};

export const snPrintDimensions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintDimensions"};

export function texprPrintDimensions(): ADL.ATypeExpr<PrintDimensions> {
  return {value : {typeRef : {kind: "reference", value : snPrintDimensions}, parameters : []}};
}

export interface PrintBorderDimensions {
  top: PrintDimension;
  left: PrintDimension;
  right: PrintDimension;
  bottom: PrintDimension;
}

export function makePrintBorderDimensions(
  input: {
    top: PrintDimension,
    left: PrintDimension,
    right: PrintDimension,
    bottom: PrintDimension,
  }
): PrintBorderDimensions {
  return {
    top: input.top,
    left: input.left,
    right: input.right,
    bottom: input.bottom,
  };
}

const PrintBorderDimensions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Top"}],"serializedName":"top","default":{"kind":"nothing"},"name":"top","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimension"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Left"}],"serializedName":"left","default":{"kind":"nothing"},"name":"left","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimension"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Right"}],"serializedName":"right","default":{"kind":"nothing"},"name":"right","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimension"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bottom"}],"serializedName":"bottom","default":{"kind":"nothing"},"name":"bottom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimension"}},"parameters":[]}}]}},"name":"PrintBorderDimensions","version":{"kind":"nothing"}}};

export const snPrintBorderDimensions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintBorderDimensions"};

export function texprPrintBorderDimensions(): ADL.ATypeExpr<PrintBorderDimensions> {
  return {value : {typeRef : {kind: "reference", value : snPrintBorderDimensions}, parameters : []}};
}

export interface PrintMediaFormat {
  pdf: (PDF|null);
  eps: (EPS|null);
  ai: (AI|null);
  indd: (INDD|null);
  psd: (PSD|null);
  quarkXPress: (QuarkXPress|null);
  other: VectorAnnotated<string>;
}

export function makePrintMediaFormat(
  input: {
    pdf?: (PDF|null),
    eps?: (EPS|null),
    ai?: (AI|null),
    indd?: (INDD|null),
    psd?: (PSD|null),
    quarkXPress?: (QuarkXPress|null),
    other?: VectorAnnotated<string>,
  }
): PrintMediaFormat {
  return {
    pdf: input.pdf === undefined ? null : input.pdf,
    eps: input.eps === undefined ? null : input.eps,
    ai: input.ai === undefined ? null : input.ai,
    indd: input.indd === undefined ? null : input.indd,
    psd: input.psd === undefined ? null : input.psd,
    quarkXPress: input.quarkXPress === undefined ? null : input.quarkXPress,
    other: input.other === undefined ? [] : input.other,
  };
}

const PrintMediaFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Print Ready PDF"}],"serializedName":"pdf","default":{"kind":"just","value":null},"name":"pdf","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PDF"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Illustrator EPS"}],"serializedName":"eps","default":{"kind":"just","value":null},"name":"eps","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"EPS"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"AI"}],"serializedName":"ai","default":{"kind":"just","value":null},"name":"ai","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AI"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"InDesign INDD"}],"serializedName":"indd","default":{"kind":"just","value":null},"name":"indd","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"INDD"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Photoshop - PSD"}],"serializedName":"psd","default":{"kind":"just","value":null},"name":"psd","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PSD"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"QuarkXPress"}],"serializedName":"quarkXPress","default":{"kind":"just","value":null},"name":"quarkXPress","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"QuarkXPress"}},"parameters":[]}]}},{"annotations":[],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"PrintMediaFormat","version":{"kind":"nothing"}}};

export const snPrintMediaFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintMediaFormat"};

export function texprPrintMediaFormat(): ADL.ATypeExpr<PrintMediaFormat> {
  return {value : {typeRef : {kind: "reference", value : snPrintMediaFormat}, parameters : []}};
}

export interface PrintNewspaper {
  dimension: (Annotated<PrintDimensions>|null);
  trim: (Annotated<PrintDimensions>|null);
  additionalPrintDimensions: (Annotated<AdditionalPrintDimensions>|null);
  textSafeArea: (Annotated<PrintBorderDimensions>|null);
  textFreeGutter: (Annotated<string>|null);
  bleed: (Annotated<PrintBorderDimensions>|null);
  finishedTrimBleed: (Annotated<PrintDimensions>|null);
  resolution: (Annotated<PrintResolution>|null);
  colourProfile: (Annotated<string>|null);
  separationProfile: (Annotated<string>|null);
  inkWeightCoverage: (Annotated<string>|null);
  blackInkLimit: (Annotated<string>|null);
  dotGain: (Annotated<string>|null);
  highlightSet: (Annotated<string>|null);
  formats: Annotated<PrintMediaFormat>;
  /**
   * Max file weight
   */
  maxFileSize: (Annotated<DataAmount>|null);
  font: (Annotated<string>|null);
  spread: (Annotated<string>|null);
  placementInNewspaper: (Annotated<string>|null);
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makePrintNewspaper(
  input: {
    dimension: (Annotated<PrintDimensions>|null),
    trim?: (Annotated<PrintDimensions>|null),
    additionalPrintDimensions?: (Annotated<AdditionalPrintDimensions>|null),
    textSafeArea?: (Annotated<PrintBorderDimensions>|null),
    textFreeGutter?: (Annotated<string>|null),
    bleed?: (Annotated<PrintBorderDimensions>|null),
    finishedTrimBleed?: (Annotated<PrintDimensions>|null),
    resolution?: (Annotated<PrintResolution>|null),
    colourProfile?: (Annotated<string>|null),
    separationProfile?: (Annotated<string>|null),
    inkWeightCoverage?: (Annotated<string>|null),
    blackInkLimit?: (Annotated<string>|null),
    dotGain?: (Annotated<string>|null),
    highlightSet?: (Annotated<string>|null),
    formats: Annotated<PrintMediaFormat>,
    maxFileSize?: (Annotated<DataAmount>|null),
    font?: (Annotated<string>|null),
    spread?: (Annotated<string>|null),
    placementInNewspaper?: (Annotated<string>|null),
    attributes?: Attributes,
  }
): PrintNewspaper {
  return {
    dimension: input.dimension,
    trim: input.trim === undefined ? null : input.trim,
    additionalPrintDimensions: input.additionalPrintDimensions === undefined ? null : input.additionalPrintDimensions,
    textSafeArea: input.textSafeArea === undefined ? null : input.textSafeArea,
    textFreeGutter: input.textFreeGutter === undefined ? null : input.textFreeGutter,
    bleed: input.bleed === undefined ? null : input.bleed,
    finishedTrimBleed: input.finishedTrimBleed === undefined ? null : input.finishedTrimBleed,
    resolution: input.resolution === undefined ? null : input.resolution,
    colourProfile: input.colourProfile === undefined ? null : input.colourProfile,
    separationProfile: input.separationProfile === undefined ? null : input.separationProfile,
    inkWeightCoverage: input.inkWeightCoverage === undefined ? null : input.inkWeightCoverage,
    blackInkLimit: input.blackInkLimit === undefined ? null : input.blackInkLimit,
    dotGain: input.dotGain === undefined ? null : input.dotGain,
    highlightSet: input.highlightSet === undefined ? null : input.highlightSet,
    formats: input.formats,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    font: input.font === undefined ? null : input.font,
    spread: input.spread === undefined ? null : input.spread,
    placementInNewspaper: input.placementInNewspaper === undefined ? null : input.placementInNewspaper,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const PrintNewspaper_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Dimension"}],"serializedName":"dimension","default":{"kind":"nothing"},"name":"dimension","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Trim"}],"serializedName":"trim","default":{"kind":"just","value":null},"name":"trim","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Additional Dimensions"}],"serializedName":"additionalPrintDimensions","default":{"kind":"just","value":null},"name":"additionalPrintDimensions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AdditionalPrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Type Safe Area"}],"serializedName":"textSafeArea","default":{"kind":"just","value":null},"name":"textSafeArea","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Text free Gutters"}],"serializedName":"textFreeGutter","default":{"kind":"just","value":null},"name":"textFreeGutter","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bleed"}],"serializedName":"bleed","default":{"kind":"just","value":null},"name":"bleed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bleed Area"}],"serializedName":"finishedTrimBleed","default":{"kind":"just","value":null},"name":"finishedTrimBleed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution"}],"serializedName":"resolution","default":{"kind":"just","value":null},"name":"resolution","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintResolution"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Colour Profile"}],"serializedName":"colourProfile","default":{"kind":"just","value":null},"name":"colourProfile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Separation Profile"}],"serializedName":"separationProfile","default":{"kind":"just","value":null},"name":"separationProfile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Ink Weight Coverage"}],"serializedName":"inkWeightCoverage","default":{"kind":"just","value":null},"name":"inkWeightCoverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Black Ink Limit"}],"serializedName":"blackInkLimit","default":{"kind":"just","value":null},"name":"blackInkLimit","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Dot Gain"}],"serializedName":"dotGain","default":{"kind":"just","value":null},"name":"dotGain","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Highlight Set"}],"serializedName":"highlightSet","default":{"kind":"just","value":null},"name":"highlightSet","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Max file weight\n"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Font"}],"serializedName":"font","default":{"kind":"just","value":null},"name":"font","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Spreads"}],"serializedName":"spread","default":{"kind":"just","value":null},"name":"spread","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Placement in Newspaper"}],"serializedName":"placementInNewspaper","default":{"kind":"just","value":null},"name":"placementInNewspaper","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"PrintNewspaper","version":{"kind":"nothing"}}};

export const snPrintNewspaper: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintNewspaper"};

export function texprPrintNewspaper(): ADL.ATypeExpr<PrintNewspaper> {
  return {value : {typeRef : {kind: "reference", value : snPrintNewspaper}, parameters : []}};
}

export interface PrintMagazine {
  trim: (Annotated<PrintDimensions>|null);
  design: (Annotated<PrintDimensions>|null);
  textSafeArea: (Annotated<PrintBorderDimensions>|null);
  bleed: (Annotated<PrintBorderDimensions>|null);
  finishedTrimBleed: (Annotated<PrintDimensions>|null);
  textFreeGutter: (Annotated<string>|null);
  resolution: (Annotated<PrintResolution>|null);
  colourProfile: (Annotated<string>|null);
  separationProfile: (Annotated<string>|null);
  inkWeightCoverage: (Annotated<string>|null);
  dotGain: (Annotated<string>|null);
  formats: Annotated<PrintMediaFormat>;
  font: (Annotated<string>|null);
  scaling: (Annotated<number>|null);
  paperType: (Annotated<string>|null);
  finish: (Annotated<string>|null);
  binding: (Annotated<string>|null);
  placementInMagazine: (Annotated<string>|null);
  /**
   * Max file weight
   */
  maxFileSize: (Annotated<DataAmount>|null);
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makePrintMagazine(
  input: {
    trim: (Annotated<PrintDimensions>|null),
    design: (Annotated<PrintDimensions>|null),
    textSafeArea?: (Annotated<PrintBorderDimensions>|null),
    bleed?: (Annotated<PrintBorderDimensions>|null),
    finishedTrimBleed?: (Annotated<PrintDimensions>|null),
    textFreeGutter?: (Annotated<string>|null),
    resolution?: (Annotated<PrintResolution>|null),
    colourProfile?: (Annotated<string>|null),
    separationProfile?: (Annotated<string>|null),
    inkWeightCoverage?: (Annotated<string>|null),
    dotGain?: (Annotated<string>|null),
    formats: Annotated<PrintMediaFormat>,
    font?: (Annotated<string>|null),
    scaling?: (Annotated<number>|null),
    paperType?: (Annotated<string>|null),
    finish?: (Annotated<string>|null),
    binding?: (Annotated<string>|null),
    placementInMagazine?: (Annotated<string>|null),
    maxFileSize?: (Annotated<DataAmount>|null),
    attributes?: Attributes,
  }
): PrintMagazine {
  return {
    trim: input.trim,
    design: input.design,
    textSafeArea: input.textSafeArea === undefined ? null : input.textSafeArea,
    bleed: input.bleed === undefined ? null : input.bleed,
    finishedTrimBleed: input.finishedTrimBleed === undefined ? null : input.finishedTrimBleed,
    textFreeGutter: input.textFreeGutter === undefined ? null : input.textFreeGutter,
    resolution: input.resolution === undefined ? null : input.resolution,
    colourProfile: input.colourProfile === undefined ? null : input.colourProfile,
    separationProfile: input.separationProfile === undefined ? null : input.separationProfile,
    inkWeightCoverage: input.inkWeightCoverage === undefined ? null : input.inkWeightCoverage,
    dotGain: input.dotGain === undefined ? null : input.dotGain,
    formats: input.formats,
    font: input.font === undefined ? null : input.font,
    scaling: input.scaling === undefined ? null : input.scaling,
    paperType: input.paperType === undefined ? null : input.paperType,
    finish: input.finish === undefined ? null : input.finish,
    binding: input.binding === undefined ? null : input.binding,
    placementInMagazine: input.placementInMagazine === undefined ? null : input.placementInMagazine,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const PrintMagazine_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Trim"}],"serializedName":"trim","default":{"kind":"nothing"},"name":"trim","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Type/Design Area"}],"serializedName":"design","default":{"kind":"nothing"},"name":"design","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Text Safe Area"}],"serializedName":"textSafeArea","default":{"kind":"just","value":null},"name":"textSafeArea","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bleed"}],"serializedName":"bleed","default":{"kind":"just","value":null},"name":"bleed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bleed Area"}],"serializedName":"finishedTrimBleed","default":{"kind":"just","value":null},"name":"finishedTrimBleed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Text free Gutters"}],"serializedName":"textFreeGutter","default":{"kind":"just","value":null},"name":"textFreeGutter","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution"}],"serializedName":"resolution","default":{"kind":"just","value":null},"name":"resolution","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintResolution"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Colour Profile"}],"serializedName":"colourProfile","default":{"kind":"just","value":null},"name":"colourProfile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Separation Profile"}],"serializedName":"separationProfile","default":{"kind":"just","value":null},"name":"separationProfile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Ink Weight Coverage"}],"serializedName":"inkWeightCoverage","default":{"kind":"just","value":null},"name":"inkWeightCoverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Dot Gain"}],"serializedName":"dotGain","default":{"kind":"just","value":null},"name":"dotGain","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Font"}],"serializedName":"font","default":{"kind":"just","value":null},"name":"font","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Image Scaling (%)"}],"serializedName":"scaling","default":{"kind":"just","value":null},"name":"scaling","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Paper Type"}],"serializedName":"paperType","default":{"kind":"just","value":null},"name":"paperType","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Finish"}],"serializedName":"finish","default":{"kind":"just","value":null},"name":"finish","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Binding"}],"serializedName":"binding","default":{"kind":"just","value":null},"name":"binding","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Placement in Magazine"}],"serializedName":"placementInMagazine","default":{"kind":"just","value":null},"name":"placementInMagazine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Max file weight\n"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"PrintMagazine","version":{"kind":"nothing"}}};

export const snPrintMagazine: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintMagazine"};

export function texprPrintMagazine(): ADL.ATypeExpr<PrintMagazine> {
  return {value : {typeRef : {kind: "reference", value : snPrintMagazine}, parameters : []}};
}

export interface PrintDimensionOptions {
  visualSize: (Annotated<PrintDimensions>|null);
  finishSize: (Annotated<PrintDimensions>|null);
}

export function makePrintDimensionOptions(
  input: {
    visualSize?: (Annotated<PrintDimensions>|null),
    finishSize?: (Annotated<PrintDimensions>|null),
  }
): PrintDimensionOptions {
  return {
    visualSize: input.visualSize === undefined ? null : input.visualSize,
    finishSize: input.finishSize === undefined ? null : input.finishSize,
  };
}

const PrintDimensionOptions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Visual Size"}],"serializedName":"visualSize","default":{"kind":"just","value":null},"name":"visualSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Finish Size"}],"serializedName":"finishSize","default":{"kind":"just","value":null},"name":"finishSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensions"}},"parameters":[]}]}]}}]}},"name":"PrintDimensionOptions","version":{"kind":"nothing"}}};

export const snPrintDimensionOptions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintDimensionOptions"};

export function texprPrintDimensionOptions(): ADL.ATypeExpr<PrintDimensionOptions> {
  return {value : {typeRef : {kind: "reference", value : snPrintDimensionOptions}, parameters : []}};
}

export interface Frontlit {
}

export function makeFrontlit(
  _input: {
  }
): Frontlit {
  return {
  };
}

const Frontlit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"Frontlit","version":{"kind":"nothing"}}};

export const snFrontlit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Frontlit"};

export function texprFrontlit(): ADL.ATypeExpr<Frontlit> {
  return {value : {typeRef : {kind: "reference", value : snFrontlit}, parameters : []}};
}

export interface Backlit {
}

export function makeBacklit(
  _input: {
  }
): Backlit {
  return {
  };
}

const Backlit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"Backlit","version":{"kind":"nothing"}}};

export const snBacklit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Backlit"};

export function texprBacklit(): ADL.ATypeExpr<Backlit> {
  return {value : {typeRef : {kind: "reference", value : snBacklit}, parameters : []}};
}

export interface FrontlitTop {
}

export function makeFrontlitTop(
  _input: {
  }
): FrontlitTop {
  return {
  };
}

const FrontlitTop_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"FrontlitTop","version":{"kind":"nothing"}}};

export const snFrontlitTop: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"FrontlitTop"};

export function texprFrontlitTop(): ADL.ATypeExpr<FrontlitTop> {
  return {value : {typeRef : {kind: "reference", value : snFrontlitTop}, parameters : []}};
}

export interface FrontlitBottom {
}

export function makeFrontlitBottom(
  _input: {
  }
): FrontlitBottom {
  return {
  };
}

const FrontlitBottom_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"FrontlitBottom","version":{"kind":"nothing"}}};

export const snFrontlitBottom: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"FrontlitBottom"};

export function texprFrontlitBottom(): ADL.ATypeExpr<FrontlitBottom> {
  return {value : {typeRef : {kind: "reference", value : snFrontlitBottom}, parameters : []}};
}

export interface Illumination_Backlit {
  kind: 'backlit';
  value: Backlit;
}
export interface Illumination_Frontlit {
  kind: 'frontlit';
  value: Frontlit;
}
export interface Illumination_FrontlitTop {
  kind: 'frontlitTop';
  value: FrontlitTop;
}
export interface Illumination_FrontlitBottom {
  kind: 'frontlitBottom';
  value: FrontlitBottom;
}

export type Illumination = Illumination_Backlit | Illumination_Frontlit | Illumination_FrontlitTop | Illumination_FrontlitBottom;

export interface IlluminationOpts {
  backlit: Backlit;
  frontlit: Frontlit;
  frontlitTop: FrontlitTop;
  frontlitBottom: FrontlitBottom;
}

export function makeIllumination<K extends keyof IlluminationOpts>(kind: K, value: IlluminationOpts[K]) { return {kind, value}; }

const Illumination_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"backlit","default":{"kind":"nothing"},"name":"backlit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Backlit"}},"parameters":[]}},{"annotations":[],"serializedName":"frontlit","default":{"kind":"nothing"},"name":"frontlit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Frontlit"}},"parameters":[]}},{"annotations":[],"serializedName":"frontlitTop","default":{"kind":"nothing"},"name":"frontlitTop","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"FrontlitTop"}},"parameters":[]}},{"annotations":[],"serializedName":"frontlitBottom","default":{"kind":"nothing"},"name":"frontlitBottom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"FrontlitBottom"}},"parameters":[]}}]}},"name":"Illumination","version":{"kind":"nothing"}}};

export const snIllumination: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Illumination"};

export function texprIllumination(): ADL.ATypeExpr<Illumination> {
  return {value : {typeRef : {kind: "reference", value : snIllumination}, parameters : []}};
}

export enum DimensionUnit {
  m,
  cm,
  mm,
}

const DimensionUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"m","default":{"kind":"nothing"},"name":"m","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cm","default":{"kind":"nothing"},"name":"cm","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"mm","default":{"kind":"nothing"},"name":"mm","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"DimensionUnit","version":{"kind":"nothing"}}};

export const snDimensionUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DimensionUnit"};

export function texprDimensionUnit(): ADL.ATypeExpr<DimensionUnit> {
  return {value : {typeRef : {kind: "reference", value : snDimensionUnit}, parameters : []}};
}

export interface PrintOOH {
  artworkDimension: (Annotated<PrintDimensionOptions>|null);
  artworkBleed: (Annotated<PrintBorderDimensions>|null);
  artworkScale: (Annotated<string>|null);
  visualSafeArea: (Annotated<common.Unit>|null);
  physicalDimension: (Annotated<PrintDimensionOptions>|null);
  physicalBleed: (Annotated<PrintBorderDimensions>|null);
  finishedEdgedDimensions: (Annotated<string>|null);
  edging: (Annotated<PrintBorderDimensions>|null);
  illumination: (Annotated<Illumination>|null);
  install: (Annotated<string>|null);
  formats: (Annotated<PrintMediaFormat>|null);
  /**
   * Max file weight
   */
  maxFileSize: (Annotated<DataAmount>|null);
  resolution: (Annotated<PrintResolution>|null);
  font: (Annotated<string>|null);
  colourProfile: (Annotated<string>|null);
  blackSpecification: (Annotated<string>|null);
  material: (Annotated<string>|null);
  materialAttributes: (Attributes|null);
  attributes: Attributes;
}

export function makePrintOOH(
  input: {
    artworkDimension?: (Annotated<PrintDimensionOptions>|null),
    artworkBleed?: (Annotated<PrintBorderDimensions>|null),
    artworkScale?: (Annotated<string>|null),
    visualSafeArea?: (Annotated<common.Unit>|null),
    physicalDimension?: (Annotated<PrintDimensionOptions>|null),
    physicalBleed?: (Annotated<PrintBorderDimensions>|null),
    finishedEdgedDimensions?: (Annotated<string>|null),
    edging?: (Annotated<PrintBorderDimensions>|null),
    illumination?: (Annotated<Illumination>|null),
    install?: (Annotated<string>|null),
    formats?: (Annotated<PrintMediaFormat>|null),
    maxFileSize?: (Annotated<DataAmount>|null),
    resolution?: (Annotated<PrintResolution>|null),
    font?: (Annotated<string>|null),
    colourProfile?: (Annotated<string>|null),
    blackSpecification?: (Annotated<string>|null),
    material?: (Annotated<string>|null),
    materialAttributes?: (Attributes|null),
    attributes?: Attributes,
  }
): PrintOOH {
  return {
    artworkDimension: input.artworkDimension === undefined ? null : input.artworkDimension,
    artworkBleed: input.artworkBleed === undefined ? null : input.artworkBleed,
    artworkScale: input.artworkScale === undefined ? null : input.artworkScale,
    visualSafeArea: input.visualSafeArea === undefined ? null : input.visualSafeArea,
    physicalDimension: input.physicalDimension === undefined ? null : input.physicalDimension,
    physicalBleed: input.physicalBleed === undefined ? null : input.physicalBleed,
    finishedEdgedDimensions: input.finishedEdgedDimensions === undefined ? null : input.finishedEdgedDimensions,
    edging: input.edging === undefined ? null : input.edging,
    illumination: input.illumination === undefined ? null : input.illumination,
    install: input.install === undefined ? null : input.install,
    formats: input.formats === undefined ? null : input.formats,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    resolution: input.resolution === undefined ? null : input.resolution,
    font: input.font === undefined ? null : input.font,
    colourProfile: input.colourProfile === undefined ? null : input.colourProfile,
    blackSpecification: input.blackSpecification === undefined ? null : input.blackSpecification,
    material: input.material === undefined ? null : input.material,
    materialAttributes: input.materialAttributes === undefined ? null : input.materialAttributes,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const PrintOOH_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Artwork Dimension"}],"serializedName":"artworkDimension","default":{"kind":"just","value":null},"name":"artworkDimension","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensionOptions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Artwork Bleed"}],"serializedName":"artworkBleed","default":{"kind":"just","value":null},"name":"artworkBleed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Artwork Scale"}],"serializedName":"artworkScale","default":{"kind":"just","value":null},"name":"artworkScale","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Visual Safe Area / Safe Zone"}],"serializedName":"visualSafeArea","default":{"kind":"just","value":null},"name":"visualSafeArea","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Physical (Actual) Dimension"}],"serializedName":"physicalDimension","default":{"kind":"just","value":null},"name":"physicalDimension","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintDimensionOptions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Actual Physical Bleed"}],"serializedName":"physicalBleed","default":{"kind":"just","value":null},"name":"physicalBleed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Finished Edged Dimensions"}],"serializedName":"finishedEdgedDimensions","default":{"kind":"just","value":null},"name":"finishedEdgedDimensions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Edging"}],"serializedName":"edging","default":{"kind":"just","value":null},"name":"edging","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintBorderDimensions"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Illumination"}],"serializedName":"illumination","default":{"kind":"just","value":null},"name":"illumination","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Illumination"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Install"}],"serializedName":"install","default":{"kind":"just","value":null},"name":"install","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Formats"}],"serializedName":"formats","default":{"kind":"just","value":null},"name":"formats","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintMediaFormat"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Max file weight\n"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution"}],"serializedName":"resolution","default":{"kind":"just","value":null},"name":"resolution","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PrintResolution"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Font"}],"serializedName":"font","default":{"kind":"just","value":null},"name":"font","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Colour Profile"}],"serializedName":"colourProfile","default":{"kind":"just","value":null},"name":"colourProfile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Black Specification"}],"serializedName":"blackSpecification","default":{"kind":"just","value":null},"name":"blackSpecification","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.http","name":"OpenApiExclude"},"v2":true},{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Old string material (deprecated)"}],"serializedName":"material","default":{"kind":"just","value":null},"name":"material","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Material"}],"serializedName":"materialAttributes","default":{"kind":"just","value":null},"name":"materialAttributes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"PrintOOH","version":{"kind":"nothing"}}};

export const snPrintOOH: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PrintOOH"};

export function texprPrintOOH(): ADL.ATypeExpr<PrintOOH> {
  return {value : {typeRef : {kind: "reference", value : snPrintOOH}, parameters : []}};
}

export interface PixelDimension {
  /**
   * Width in pixels
   */
  width: number;
  /**
   * Height in pixels
   */
  height: number;
}

export function makePixelDimension(
  input: {
    width: number,
    height: number,
  }
): PixelDimension {
  return {
    width: input.width,
    height: input.height,
  };
}

const PixelDimension_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Width (pixels)"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Width in pixels\n"}],"serializedName":"width","default":{"kind":"nothing"},"name":"width","typeExpr":{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Height (pixels)"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Height in pixels\n"}],"serializedName":"height","default":{"kind":"nothing"},"name":"height","typeExpr":{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}}]}},"name":"PixelDimension","version":{"kind":"nothing"}}};

export const snPixelDimension: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PixelDimension"};

export function texprPixelDimension(): ADL.ATypeExpr<PixelDimension> {
  return {value : {typeRef : {kind: "reference", value : snPixelDimension}, parameters : []}};
}

/**
 * Listing of dimension properties in a flat list.
 *   - covers variations by standard/retina expanded/collapsed
 *   - May be used to cover *minor* cases of alternate dimensions (major alternate cases should be different placements entirely)
 */
export type DigitalMediaDimensions = VectorNamedAnnotated<DigitalMediaDimension>;

const DigitalMediaDimensions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Listing of dimension properties in a flat list.\n  - covers variations by standard/retina expanded/collapsed\n  - May be used to cover *minor* cases of alternate dimensions (major alternate cases should be different placements entirely)\n"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorNamedAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalMediaDimension"}},"parameters":[]}]}}},"name":"DigitalMediaDimensions","version":{"kind":"nothing"}}};

export const snDigitalMediaDimensions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DigitalMediaDimensions"};

export function texprDigitalMediaDimensions(): ADL.ATypeExpr<DigitalMediaDimensions> {
  return {value : {typeRef : {kind: "reference", value : snDigitalMediaDimensions}, parameters : []}};
}

/**
 * Dimension property for Display media - Where combinations of retina/standard and expanded/collapsed are needed.
 */
export interface DigitalMediaDimension {
  pixelDimension: PixelDimension;
  /**
   * Resolution type
   */
  resolutionType: (DimensionResolutionType|null);
  sizeCase: (DimensionSizeCase|null);
}

export function makeDigitalMediaDimension(
  input: {
    pixelDimension: PixelDimension,
    resolutionType?: (DimensionResolutionType|null),
    sizeCase?: (DimensionSizeCase|null),
  }
): DigitalMediaDimension {
  return {
    pixelDimension: input.pixelDimension,
    resolutionType: input.resolutionType === undefined ? null : input.resolutionType,
    sizeCase: input.sizeCase === undefined ? null : input.sizeCase,
  };
}

const DigitalMediaDimension_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Dimension property for Display media - Where combinations of retina/standard and expanded/collapsed are needed.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"pixelDimension","default":{"kind":"nothing"},"name":"pixelDimension","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PixelDimension"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution type"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Resolution type\n"}],"serializedName":"resolutionType","default":{"kind":"just","value":null},"name":"resolutionType","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DimensionResolutionType"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"At Size"}],"serializedName":"sizeCase","default":{"kind":"just","value":null},"name":"sizeCase","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DimensionSizeCase"}},"parameters":[]}]}}]}},"name":"DigitalMediaDimension","version":{"kind":"nothing"}}};

export const snDigitalMediaDimension: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DigitalMediaDimension"};

export function texprDigitalMediaDimension(): ADL.ATypeExpr<DigitalMediaDimension> {
  return {value : {typeRef : {kind: "reference", value : snDigitalMediaDimension}, parameters : []}};
}

export interface DimensionResolutionType_Standard {
  kind: 'standard';
}
export interface DimensionResolutionType_Retina {
  kind: 'retina';
}
export interface DimensionResolutionType_Other {
  kind: 'other';
  value: string;
}

/**
 * Dimension Resolution Type (standard or retina)
 */
export type DimensionResolutionType = DimensionResolutionType_Standard | DimensionResolutionType_Retina | DimensionResolutionType_Other;

export interface DimensionResolutionTypeOpts {
  standard: null;
  retina: null;
  other: string;
}

export function makeDimensionResolutionType<K extends keyof DimensionResolutionTypeOpts>(kind: K, value: DimensionResolutionTypeOpts[K]) { return {kind, value}; }

const DimensionResolutionType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Dimension Resolution Type (standard or retina)\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Standard"}],"serializedName":"standard","default":{"kind":"nothing"},"name":"standard","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Retina"}],"serializedName":"retina","default":{"kind":"nothing"},"name":"retina","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"other","default":{"kind":"nothing"},"name":"other","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"DimensionResolutionType","version":{"kind":"nothing"}}};

export const snDimensionResolutionType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DimensionResolutionType"};

export function texprDimensionResolutionType(): ADL.ATypeExpr<DimensionResolutionType> {
  return {value : {typeRef : {kind: "reference", value : snDimensionResolutionType}, parameters : []}};
}

export interface DimensionSizeCase_Regular {
  kind: 'regular';
}
export interface DimensionSizeCase_Expanded {
  kind: 'expanded';
}
export interface DimensionSizeCase_Collapsed {
  kind: 'collapsed';
}
export interface DimensionSizeCase_Other {
  kind: 'other';
  value: string;
}

/**
 * Dimension size use-case (regular vs expanded or collapsed)
 */
export type DimensionSizeCase = DimensionSizeCase_Regular | DimensionSizeCase_Expanded | DimensionSizeCase_Collapsed | DimensionSizeCase_Other;

export interface DimensionSizeCaseOpts {
  regular: null;
  expanded: null;
  collapsed: null;
  other: string;
}

export function makeDimensionSizeCase<K extends keyof DimensionSizeCaseOpts>(kind: K, value: DimensionSizeCaseOpts[K]) { return {kind, value}; }

const DimensionSizeCase_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Dimension size use-case (regular vs expanded or collapsed)\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Regular"}],"serializedName":"regular","default":{"kind":"nothing"},"name":"regular","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Expanded"}],"serializedName":"expanded","default":{"kind":"nothing"},"name":"expanded","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Collapsed"}],"serializedName":"collapsed","default":{"kind":"nothing"},"name":"collapsed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"other","default":{"kind":"nothing"},"name":"other","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"DimensionSizeCase","version":{"kind":"nothing"}}};

export const snDimensionSizeCase: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DimensionSizeCase"};

export function texprDimensionSizeCase(): ADL.ATypeExpr<DimensionSizeCase> {
  return {value : {typeRef : {kind: "reference", value : snDimensionSizeCase}, parameters : []}};
}

/**
 * Static media format
 */
export interface StaticMediaFormat {
  jpg: (JPG|null);
  bmp: (BMP|null);
  gif: (GIF|null);
  png: (PNG|null);
  eps: (EPS|null);
  ai: (AI|null);
  tiff: (TIFF|null);
  psdLayered: (PSD|null);
  psdFlattened: (PSD|null);
  svg: (SVG|null);
  other: VectorAnnotated<string>;
}

export function makeStaticMediaFormat(
  input: {
    jpg?: (JPG|null),
    bmp?: (BMP|null),
    gif?: (GIF|null),
    png?: (PNG|null),
    eps?: (EPS|null),
    ai?: (AI|null),
    tiff?: (TIFF|null),
    psdLayered?: (PSD|null),
    psdFlattened?: (PSD|null),
    svg?: (SVG|null),
    other?: VectorAnnotated<string>,
  }
): StaticMediaFormat {
  return {
    jpg: input.jpg === undefined ? null : input.jpg,
    bmp: input.bmp === undefined ? null : input.bmp,
    gif: input.gif === undefined ? null : input.gif,
    png: input.png === undefined ? null : input.png,
    eps: input.eps === undefined ? null : input.eps,
    ai: input.ai === undefined ? null : input.ai,
    tiff: input.tiff === undefined ? null : input.tiff,
    psdLayered: input.psdLayered === undefined ? null : input.psdLayered,
    psdFlattened: input.psdFlattened === undefined ? null : input.psdFlattened,
    svg: input.svg === undefined ? null : input.svg,
    other: input.other === undefined ? [] : input.other,
  };
}

const StaticMediaFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Static media format\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"JPG / JPEG"}],"serializedName":"jpg","default":{"kind":"just","value":null},"name":"jpg","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"JPG"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"BMP"}],"serializedName":"bmp","default":{"kind":"just","value":null},"name":"bmp","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"BMP"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"GIF (Static)"}],"serializedName":"gif","default":{"kind":"just","value":null},"name":"gif","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"GIF"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"PNG"}],"serializedName":"png","default":{"kind":"just","value":null},"name":"png","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PNG"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"EPS"}],"serializedName":"eps","default":{"kind":"just","value":null},"name":"eps","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"EPS"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"AI"}],"serializedName":"ai","default":{"kind":"just","value":null},"name":"ai","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AI"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"TIFF"}],"serializedName":"tiff","default":{"kind":"just","value":null},"name":"tiff","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"TIFF"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"PSD (layered)"}],"serializedName":"psdLayered","default":{"kind":"just","value":null},"name":"psdLayered","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PSD"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"PSD (flattened)"}],"serializedName":"psdFlattened","default":{"kind":"just","value":null},"name":"psdFlattened","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PSD"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"SVG"}],"serializedName":"svg","default":{"kind":"just","value":null},"name":"svg","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"SVG"}},"parameters":[]}]}},{"annotations":[],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"StaticMediaFormat","version":{"kind":"nothing"}}};

export const snStaticMediaFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"StaticMediaFormat"};

export function texprStaticMediaFormat(): ADL.ATypeExpr<StaticMediaFormat> {
  return {value : {typeRef : {kind: "reference", value : snStaticMediaFormat}, parameters : []}};
}

/**
 * JPG Specification details
 */
export interface JPG {
}

export function makeJPG(
  _input: {
  }
): JPG {
  return {
  };
}

const JPG_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"JPG Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"JPG","version":{"kind":"nothing"}}};

export const snJPG: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"JPG"};

export function texprJPG(): ADL.ATypeExpr<JPG> {
  return {value : {typeRef : {kind: "reference", value : snJPG}, parameters : []}};
}

/**
 * BMP Specification details
 */
export interface BMP {
}

export function makeBMP(
  _input: {
  }
): BMP {
  return {
  };
}

const BMP_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"BMP Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"BMP","version":{"kind":"nothing"}}};

export const snBMP: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"BMP"};

export function texprBMP(): ADL.ATypeExpr<BMP> {
  return {value : {typeRef : {kind: "reference", value : snBMP}, parameters : []}};
}

/**
 * SVG Specification details
 */
export interface SVG {
}

export function makeSVG(
  _input: {
  }
): SVG {
  return {
  };
}

const SVG_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"SVG Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"SVG","version":{"kind":"nothing"}}};

export const snSVG: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"SVG"};

export function texprSVG(): ADL.ATypeExpr<SVG> {
  return {value : {typeRef : {kind: "reference", value : snSVG}, parameters : []}};
}

/**
 * GIF Specification details
 */
export interface GIF {
  /**
   * Transparency
   */
  transparency: (common.Unit|null);
}

export function makeGIF(
  input: {
    transparency?: (common.Unit|null),
  }
): GIF {
  return {
    transparency: input.transparency === undefined ? null : input.transparency,
  };
}

const GIF_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"GIF Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Transparency\n"}],"serializedName":"transparency","default":{"kind":"just","value":null},"name":"transparency","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"GIF","version":{"kind":"nothing"}}};

export const snGIF: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"GIF"};

export function texprGIF(): ADL.ATypeExpr<GIF> {
  return {value : {typeRef : {kind: "reference", value : snGIF}, parameters : []}};
}

/**
 * PDF Specification details
 */
export interface PDF {
}

export function makePDF(
  _input: {
  }
): PDF {
  return {
  };
}

const PDF_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"PDF Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"PDF","version":{"kind":"nothing"}}};

export const snPDF: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PDF"};

export function texprPDF(): ADL.ATypeExpr<PDF> {
  return {value : {typeRef : {kind: "reference", value : snPDF}, parameters : []}};
}

/**
 * INDD Specification details
 */
export interface INDD {
}

export function makeINDD(
  _input: {
  }
): INDD {
  return {
  };
}

const INDD_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"INDD Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"INDD","version":{"kind":"nothing"}}};

export const snINDD: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"INDD"};

export function texprINDD(): ADL.ATypeExpr<INDD> {
  return {value : {typeRef : {kind: "reference", value : snINDD}, parameters : []}};
}

/**
 * QuarkXPress Specification details
 */
export interface QuarkXPress {
}

export function makeQuarkXPress(
  _input: {
  }
): QuarkXPress {
  return {
  };
}

const QuarkXPress_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"QuarkXPress Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"QuarkXPress","version":{"kind":"nothing"}}};

export const snQuarkXPress: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"QuarkXPress"};

export function texprQuarkXPress(): ADL.ATypeExpr<QuarkXPress> {
  return {value : {typeRef : {kind: "reference", value : snQuarkXPress}, parameters : []}};
}

/**
 * PNG Specification details
 */
export interface PNG {
  transparency: (common.Unit|null);
  /**
   * PNG 8
   */
  png8: (PNGFormat|null);
  /**
   * PNG 24
   */
  png24: (PNGFormat|null);
}

export function makePNG(
  input: {
    transparency?: (common.Unit|null),
    png8?: (PNGFormat|null),
    png24?: (PNGFormat|null),
  }
): PNG {
  return {
    transparency: input.transparency === undefined ? null : input.transparency,
    png8: input.png8 === undefined ? null : input.png8,
    png24: input.png24 === undefined ? null : input.png24,
  };
}

const PNG_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"PNG Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"transparency","default":{"kind":"just","value":null},"name":"transparency","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"PNG 8\n"}],"serializedName":"png8","default":{"kind":"just","value":null},"name":"png8","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PNGFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"PNG 24\n"}],"serializedName":"png24","default":{"kind":"just","value":null},"name":"png24","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PNGFormat"}},"parameters":[]}]}}]}},"name":"PNG","version":{"kind":"nothing"}}};

export const snPNG: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PNG"};

export function texprPNG(): ADL.ATypeExpr<PNG> {
  return {value : {typeRef : {kind: "reference", value : snPNG}, parameters : []}};
}

export interface PNGFormat {
}

export function makePNGFormat(
  _input: {
  }
): PNGFormat {
  return {
  };
}

const PNGFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"PNGFormat","version":{"kind":"nothing"}}};

export const snPNGFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PNGFormat"};

export function texprPNGFormat(): ADL.ATypeExpr<PNGFormat> {
  return {value : {typeRef : {kind: "reference", value : snPNGFormat}, parameters : []}};
}

/**
 * EPS Specification details
 */
export interface EPS {
  /**
   * Convert text to outline
   */
  convertToOutline: (common.Unit|null);
}

export function makeEPS(
  input: {
    convertToOutline?: (common.Unit|null),
  }
): EPS {
  return {
    convertToOutline: input.convertToOutline === undefined ? null : input.convertToOutline,
  };
}

const EPS_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"EPS Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Convert text to outline\n"}],"serializedName":"convertToOutline","default":{"kind":"just","value":null},"name":"convertToOutline","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"EPS","version":{"kind":"nothing"}}};

export const snEPS: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"EPS"};

export function texprEPS(): ADL.ATypeExpr<EPS> {
  return {value : {typeRef : {kind: "reference", value : snEPS}, parameters : []}};
}

export interface AI {
  /**
   * Convert text to outline
   */
  convertToOutline: (common.Unit|null);
}

export function makeAI(
  input: {
    convertToOutline?: (common.Unit|null),
  }
): AI {
  return {
    convertToOutline: input.convertToOutline === undefined ? null : input.convertToOutline,
  };
}

const AI_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Convert text to outline\n"}],"serializedName":"convertToOutline","default":{"kind":"just","value":null},"name":"convertToOutline","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"AI","version":{"kind":"nothing"}}};

export const snAI: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AI"};

export function texprAI(): ADL.ATypeExpr<AI> {
  return {value : {typeRef : {kind: "reference", value : snAI}, parameters : []}};
}

/**
 * TIFF Specification details
 */
export interface TIFF {
}

export function makeTIFF(
  _input: {
  }
): TIFF {
  return {
  };
}

const TIFF_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"TIFF Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"TIFF","version":{"kind":"nothing"}}};

export const snTIFF: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"TIFF"};

export function texprTIFF(): ADL.ATypeExpr<TIFF> {
  return {value : {typeRef : {kind: "reference", value : snTIFF}, parameters : []}};
}

export interface PSD {
  /**
   * PSD Example url
   */
  psdExampleUrl: (kachemedia_specsheet_common.Url|null);
}

export function makePSD(
  input: {
    psdExampleUrl?: (kachemedia_specsheet_common.Url|null),
  }
): PSD {
  return {
    psdExampleUrl: input.psdExampleUrl === undefined ? null : input.psdExampleUrl,
  };
}

const PSD_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Example PSD Image Url"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"PSD Example url\n"}],"serializedName":"psdExampleUrl","default":{"kind":"just","value":null},"name":"psdExampleUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Url"}},"parameters":[]}]}}]}},"name":"PSD","version":{"kind":"nothing"}}};

export const snPSD: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"PSD"};

export function texprPSD(): ADL.ATypeExpr<PSD> {
  return {value : {typeRef : {kind: "reference", value : snPSD}, parameters : []}};
}

/**
 * Helper type for the UI to splat out the format fields
 */
export interface AnyFormatDetails {
  png8: (PNGFormat|null);
  png24: (PNGFormat|null);
  transparency: (common.Unit|null);
  convertToOutline: (common.Unit|null);
  psdExampleUrl: (kachemedia_specsheet_common.Url|null);
}

export function makeAnyFormatDetails(
  input: {
    png8?: (PNGFormat|null),
    png24?: (PNGFormat|null),
    transparency?: (common.Unit|null),
    convertToOutline?: (common.Unit|null),
    psdExampleUrl?: (kachemedia_specsheet_common.Url|null),
  }
): AnyFormatDetails {
  return {
    png8: input.png8 === undefined ? null : input.png8,
    png24: input.png24 === undefined ? null : input.png24,
    transparency: input.transparency === undefined ? null : input.transparency,
    convertToOutline: input.convertToOutline === undefined ? null : input.convertToOutline,
    psdExampleUrl: input.psdExampleUrl === undefined ? null : input.psdExampleUrl,
  };
}

const AnyFormatDetails_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Helper type for the UI to splat out the format fields\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"png8","default":{"kind":"just","value":null},"name":"png8","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PNGFormat"}},"parameters":[]}]}},{"annotations":[],"serializedName":"png24","default":{"kind":"just","value":null},"name":"png24","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"PNGFormat"}},"parameters":[]}]}},{"annotations":[],"serializedName":"transparency","default":{"kind":"just","value":null},"name":"transparency","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"convertToOutline","default":{"kind":"just","value":null},"name":"convertToOutline","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"psdExampleUrl","default":{"kind":"just","value":null},"name":"psdExampleUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Url"}},"parameters":[]}]}}]}},"name":"AnyFormatDetails","version":{"kind":"nothing"}}};

export const snAnyFormatDetails: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AnyFormatDetails"};

export function texprAnyFormatDetails(): ADL.ATypeExpr<AnyFormatDetails> {
  return {value : {typeRef : {kind: "reference", value : snAnyFormatDetails}, parameters : []}};
}

/**
 * Listing of DataAmount properties in a flat list.
 *   - covers listing various fixed-category sizes or user named parts
 */
export type DataAmounts = VectorNamedAnnotated<DataAmountProperty>;

const DataAmounts_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Listing of DataAmount properties in a flat list.\n  - covers listing various fixed-category sizes or user named parts\n"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorNamedAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmountProperty"}},"parameters":[]}]}}},"name":"DataAmounts","version":{"kind":"nothing"}}};

export const snDataAmounts: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DataAmounts"};

export function texprDataAmounts(): ADL.ATypeExpr<DataAmounts> {
  return {value : {typeRef : {kind: "reference", value : snDataAmounts}, parameters : []}};
}

export interface DataAmountProperty {
  amount: DataAmount;
  kind: DataAmountType;
}

export function makeDataAmountProperty(
  input: {
    amount: DataAmount,
    kind: DataAmountType,
  }
): DataAmountProperty {
  return {
    amount: input.amount,
    kind: input.kind,
  };
}

const DataAmountProperty_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}},{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmountType"}},"parameters":[]}}]}},"name":"DataAmountProperty","version":{"kind":"nothing"}}};

export const snDataAmountProperty: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DataAmountProperty"};

export function texprDataAmountProperty(): ADL.ATypeExpr<DataAmountProperty> {
  return {value : {typeRef : {kind: "reference", value : snDataAmountProperty}, parameters : []}};
}

export interface DataAmountType_Total {
  kind: 'total';
}
export interface DataAmountType_Initial {
  kind: 'initial';
}
export interface DataAmountType_Polite {
  kind: 'polite';
}
export interface DataAmountType_UserInitiated {
  kind: 'userInitiated';
}
export interface DataAmountType_AdVerificationScripts {
  kind: 'adVerificationScripts';
}
export interface DataAmountType_HostedSharedLibrary {
  kind: 'hostedSharedLibrary';
}
export interface DataAmountType_Other {
  kind: 'other';
  value: string;
}

export type DataAmountType = DataAmountType_Total | DataAmountType_Initial | DataAmountType_Polite | DataAmountType_UserInitiated | DataAmountType_AdVerificationScripts | DataAmountType_HostedSharedLibrary | DataAmountType_Other;

export interface DataAmountTypeOpts {
  total: null;
  initial: null;
  polite: null;
  userInitiated: null;
  adVerificationScripts: null;
  hostedSharedLibrary: null;
  /**
   * Other named (eg: splits by file type, js, css etc)
   */
  other: string;
}

export function makeDataAmountType<K extends keyof DataAmountTypeOpts>(kind: K, value: DataAmountTypeOpts[K]) { return {kind, value}; }

const DataAmountType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Total File Size"}],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Initial Load"}],"serializedName":"initial","default":{"kind":"nothing"},"name":"initial","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Polite Load"}],"serializedName":"polite","default":{"kind":"nothing"},"name":"polite","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"User Initiated Load"}],"serializedName":"userInitiated","default":{"kind":"nothing"},"name":"userInitiated","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Ad Verification Scripts"}],"serializedName":"adVerificationScripts","default":{"kind":"nothing"},"name":"adVerificationScripts","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Hosted shared library"}],"serializedName":"hostedSharedLibrary","default":{"kind":"nothing"},"name":"hostedSharedLibrary","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Other named (eg: splits by file type, js, css etc)\n"}],"serializedName":"other","default":{"kind":"nothing"},"name":"other","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"DataAmountType","version":{"kind":"nothing"}}};

export const snDataAmountType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DataAmountType"};

export function texprDataAmountType(): ADL.ATypeExpr<DataAmountType> {
  return {value : {typeRef : {kind: "reference", value : snDataAmountType}, parameters : []}};
}

/**
 * Animated Media
 */
export interface AnimatedMedia {
  /**
   * Media dimensions
   */
  dimensions: Annotated<DigitalMediaDimensions>;
  /**
   * Duration of the animation
   */
  durations: Annotated<Durations>;
  loop: (Annotated<common.Unit>|null);
  /**
   * Number of times to loop
   */
  loopCount: (Annotated<number>|null);
  /**
   * Animation must end with a static frame?
   */
  endWithStaticFrame: Annotated<boolean>;
  safeZone: (Annotated<common.Unit>|null);
  DPI: (Annotated<number>|null);
  resolution: (Annotated<DigitalResolution>|null);
  /**
   * Color space
   */
  color: (Annotated<RGBOnlyColorSpace>|null);
  border: (Annotated<Border>|null);
  /**
   * Supported formats for animated media
   */
  formats: Annotated<AnimatedMediaFormat>;
  /**
   * Max file weight
   */
  maxFileSize: (Annotated<DataAmount>|null);
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makeAnimatedMedia(
  input: {
    dimensions: Annotated<DigitalMediaDimensions>,
    durations: Annotated<Durations>,
    loop?: (Annotated<common.Unit>|null),
    loopCount?: (Annotated<number>|null),
    endWithStaticFrame: Annotated<boolean>,
    safeZone?: (Annotated<common.Unit>|null),
    DPI?: (Annotated<number>|null),
    resolution?: (Annotated<DigitalResolution>|null),
    color?: (Annotated<RGBOnlyColorSpace>|null),
    border?: (Annotated<Border>|null),
    formats: Annotated<AnimatedMediaFormat>,
    maxFileSize?: (Annotated<DataAmount>|null),
    attributes?: Attributes,
  }
): AnimatedMedia {
  return {
    dimensions: input.dimensions,
    durations: input.durations,
    loop: input.loop === undefined ? null : input.loop,
    loopCount: input.loopCount === undefined ? null : input.loopCount,
    endWithStaticFrame: input.endWithStaticFrame,
    safeZone: input.safeZone === undefined ? null : input.safeZone,
    DPI: input.DPI === undefined ? null : input.DPI,
    resolution: input.resolution === undefined ? null : input.resolution,
    color: input.color === undefined ? null : input.color,
    border: input.border === undefined ? null : input.border,
    formats: input.formats,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const AnimatedMedia_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Animated Media\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Media dimensions\n"}],"serializedName":"dimensions","default":{"kind":"nothing"},"name":"dimensions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalMediaDimensions"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Duration"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Duration of the animation\n"}],"serializedName":"durations","default":{"kind":"nothing"},"name":"durations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Durations"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Looping"}],"serializedName":"loop","default":{"kind":"just","value":null},"name":"loop","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Number of times to loop"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Number of times to loop\n"}],"serializedName":"loopCount","default":{"kind":"just","value":null},"name":"loopCount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Must end with a static frame?"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Animation must end with a static frame?\n"}],"serializedName":"endWithStaticFrame","default":{"kind":"nothing"},"name":"endWithStaticFrame","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Safe Zone"}],"serializedName":"safeZone","default":{"kind":"just","value":null},"name":"safeZone","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.http","name":"OpenApiExclude"},"v2":true},{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution (DPI) (Deprecated)"}],"serializedName":"DPI","default":{"kind":"just","value":null},"name":"DPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution"}],"serializedName":"resolution","default":{"kind":"just","value":null},"name":"resolution","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalResolution"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Color Space"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Color space\n"}],"serializedName":"color","default":{"kind":"just","value":null},"name":"color","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"RGBOnlyColorSpace"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Border"}],"serializedName":"border","default":{"kind":"just","value":null},"name":"border","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Border"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported formats for animated media\n"}],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AnimatedMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Max file weight\n"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"AnimatedMedia","version":{"kind":"nothing"}}};

export const snAnimatedMedia: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AnimatedMedia"};

export function texprAnimatedMedia(): ADL.ATypeExpr<AnimatedMedia> {
  return {value : {typeRef : {kind: "reference", value : snAnimatedMedia}, parameters : []}};
}

export interface Border_SinglePixel {
  kind: 'singlePixel';
}
export interface Border_Other {
  kind: 'other';
  value: string;
}

export type Border = Border_SinglePixel | Border_Other;

export interface BorderOpts {
  singlePixel: null;
  other: string;
}

export function makeBorder<K extends keyof BorderOpts>(kind: K, value: BorderOpts[K]) { return {kind, value}; }

const Border_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"1px border"}],"serializedName":"singlePixel","default":{"kind":"nothing"},"name":"singlePixel","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"other","default":{"kind":"nothing"},"name":"other","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Border","version":{"kind":"nothing"}}};

export const snBorder: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Border"};

export function texprBorder(): ADL.ATypeExpr<Border> {
  return {value : {typeRef : {kind: "reference", value : snBorder}, parameters : []}};
}

/**
 * Listing of Duration properties in a flat list.
 *   - could be one of several supported durations
 */
export type Durations = VectorNamedAnnotated<Duration>;

const Durations_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Listing of Duration properties in a flat list.\n  - could be one of several supported durations\n"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorNamedAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Duration"}},"parameters":[]}]}}},"name":"Durations","version":{"kind":"nothing"}}};

export const snDurations: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Durations"};

export function texprDurations(): ADL.ATypeExpr<Durations> {
  return {value : {typeRef : {kind: "reference", value : snDurations}, parameters : []}};
}

export interface Duration {
  hours: (number|null);
  minutes: (number|null);
  seconds: (number|null);
  milliSeconds: (number|null);
}

export function makeDuration(
  input: {
    hours?: (number|null),
    minutes?: (number|null),
    seconds?: (number|null),
    milliSeconds?: (number|null),
  }
): Duration {
  return {
    hours: input.hours === undefined ? null : input.hours,
    minutes: input.minutes === undefined ? null : input.minutes,
    seconds: input.seconds === undefined ? null : input.seconds,
    milliSeconds: input.milliSeconds === undefined ? null : input.milliSeconds,
  };
}

const Duration_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hours","default":{"kind":"just","value":null},"name":"hours","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}},{"annotations":[],"serializedName":"minutes","default":{"kind":"just","value":null},"name":"minutes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}},{"annotations":[],"serializedName":"seconds","default":{"kind":"just","value":null},"name":"seconds","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}},{"annotations":[],"serializedName":"milliSeconds","default":{"kind":"just","value":null},"name":"milliSeconds","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}}]}},"name":"Duration","version":{"kind":"nothing"}}};

export const snDuration: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Duration"};

export function texprDuration(): ADL.ATypeExpr<Duration> {
  return {value : {typeRef : {kind: "reference", value : snDuration}, parameters : []}};
}

/**
 * Animated media format
 */
export interface AnimatedMediaFormat {
  gif: (GIF|null);
  other: VectorAnnotated<string>;
}

export function makeAnimatedMediaFormat(
  input: {
    gif?: (GIF|null),
    other?: VectorAnnotated<string>,
  }
): AnimatedMediaFormat {
  return {
    gif: input.gif === undefined ? null : input.gif,
    other: input.other === undefined ? [] : input.other,
  };
}

const AnimatedMediaFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Animated media format\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"GIF (Animated)"}],"serializedName":"gif","default":{"kind":"just","value":null},"name":"gif","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"GIF"}},"parameters":[]}]}},{"annotations":[],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"AnimatedMediaFormat","version":{"kind":"nothing"}}};

export const snAnimatedMediaFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AnimatedMediaFormat"};

export function texprAnimatedMediaFormat(): ADL.ATypeExpr<AnimatedMediaFormat> {
  return {value : {typeRef : {kind: "reference", value : snAnimatedMediaFormat}, parameters : []}};
}

/**
 * Html5 formats
 */
export interface Html5Formats {
  /**
   * Supported formats
   */
  static: Annotated<StaticMediaFormat>;
  /**
   * Animated media formats
   */
  animated: Annotated<AnimatedMediaFormat>;
  /**
   * Web media formats
   */
  web: Annotated<WebMediaFormat>;
  /**
   * Video media format
   */
  video: (Annotated<Html5Video>|null);
}

export function makeHtml5Formats(
  input: {
    static: Annotated<StaticMediaFormat>,
    animated: Annotated<AnimatedMediaFormat>,
    web: Annotated<WebMediaFormat>,
    video?: (Annotated<Html5Video>|null),
  }
): Html5Formats {
  return {
    static: input.static,
    animated: input.animated,
    web: input.web,
    video: input.video === undefined ? null : input.video,
  };
}

const Html5Formats_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Html5 formats\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported formats\n"}],"serializedName":"static","default":{"kind":"nothing"},"name":"static","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"StaticMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Animated media formats\n"}],"serializedName":"animated","default":{"kind":"nothing"},"name":"animated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AnimatedMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Coding Format"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Web media formats\n"}],"serializedName":"web","default":{"kind":"nothing"},"name":"web","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"WebMediaFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Video media format\n"}],"serializedName":"video","default":{"kind":"just","value":null},"name":"video","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Html5Video"}},"parameters":[]}]}]}}]}},"name":"Html5Formats","version":{"kind":"nothing"}}};

export const snHtml5Formats: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Html5Formats"};

export function texprHtml5Formats(): ADL.ATypeExpr<Html5Formats> {
  return {value : {typeRef : {kind: "reference", value : snHtml5Formats}, parameters : []}};
}

export interface WebMediaFormat {
  HTML5: (common.Unit|null);
  CSS: (common.Unit|null);
  JS: (common.Unit|null);
}

export function makeWebMediaFormat(
  input: {
    HTML5?: (common.Unit|null),
    CSS?: (common.Unit|null),
    JS?: (common.Unit|null),
  }
): WebMediaFormat {
  return {
    HTML5: input.HTML5 === undefined ? null : input.HTML5,
    CSS: input.CSS === undefined ? null : input.CSS,
    JS: input.JS === undefined ? null : input.JS,
  };
}

const WebMediaFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"HTML5","default":{"kind":"just","value":null},"name":"HTML5","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"CSS","default":{"kind":"just","value":null},"name":"CSS","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"JS","default":{"kind":"just","value":null},"name":"JS","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"WebMediaFormat","version":{"kind":"nothing"}}};

export const snWebMediaFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"WebMediaFormat"};

export function texprWebMediaFormat(): ADL.ATypeExpr<WebMediaFormat> {
  return {value : {typeRef : {kind: "reference", value : snWebMediaFormat}, parameters : []}};
}

export interface Html5Video {
  video: Video;
}

export function makeHtml5Video(
  input: {
    video: Video,
  }
): Html5Video {
  return {
    video: input.video,
  };
}

const Html5Video_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"video","default":{"kind":"nothing"},"name":"video","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Video"}},"parameters":[]}}]}},"name":"Html5Video","version":{"kind":"nothing"}}};

export const snHtml5Video: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Html5Video"};

export function texprHtml5Video(): ADL.ATypeExpr<Html5Video> {
  return {value : {typeRef : {kind: "reference", value : snHtml5Video}, parameters : []}};
}

/**
 * HTML Media Specification details
 */
export interface Html5Media {
  /**
   * Media dimensions
   */
  dimensions: Annotated<DigitalMediaDimensions>;
  safeZone: (Annotated<common.Unit>|null);
  DPI: (Annotated<number>|null);
  resolution: (Annotated<DigitalResolution>|null);
  color: (Annotated<DigitalColorSpace>|null);
  border: (Annotated<Border>|null);
  dataAmounts: (Annotated<DataAmounts>|null);
  /**
   * Formats
   */
  formats: Annotated<Html5Formats>;
  /**
   * Duration of the animation
   */
  durations: (Annotated<Durations>|null);
  /**
   * Frame rate
   */
  frameRate: (Annotated<FrameRate>|null);
  loop: (Annotated<common.Unit>|null);
  loopCount: (Annotated<number>|null);
  accepted3rdPartyVendors: (Attributes|null);
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makeHtml5Media(
  input: {
    dimensions: Annotated<DigitalMediaDimensions>,
    safeZone?: (Annotated<common.Unit>|null),
    DPI?: (Annotated<number>|null),
    resolution?: (Annotated<DigitalResolution>|null),
    color?: (Annotated<DigitalColorSpace>|null),
    border?: (Annotated<Border>|null),
    dataAmounts?: (Annotated<DataAmounts>|null),
    formats: Annotated<Html5Formats>,
    durations?: (Annotated<Durations>|null),
    frameRate?: (Annotated<FrameRate>|null),
    loop?: (Annotated<common.Unit>|null),
    loopCount?: (Annotated<number>|null),
    accepted3rdPartyVendors?: (Attributes|null),
    attributes?: Attributes,
  }
): Html5Media {
  return {
    dimensions: input.dimensions,
    safeZone: input.safeZone === undefined ? null : input.safeZone,
    DPI: input.DPI === undefined ? null : input.DPI,
    resolution: input.resolution === undefined ? null : input.resolution,
    color: input.color === undefined ? null : input.color,
    border: input.border === undefined ? null : input.border,
    dataAmounts: input.dataAmounts === undefined ? null : input.dataAmounts,
    formats: input.formats,
    durations: input.durations === undefined ? null : input.durations,
    frameRate: input.frameRate === undefined ? null : input.frameRate,
    loop: input.loop === undefined ? null : input.loop,
    loopCount: input.loopCount === undefined ? null : input.loopCount,
    accepted3rdPartyVendors: input.accepted3rdPartyVendors === undefined ? null : input.accepted3rdPartyVendors,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const Html5Media_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"HTML Media Specification details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Media dimensions\n"}],"serializedName":"dimensions","default":{"kind":"nothing"},"name":"dimensions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalMediaDimensions"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Safe Zone"}],"serializedName":"safeZone","default":{"kind":"just","value":null},"name":"safeZone","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.http","name":"OpenApiExclude"},"v2":true},{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution (DPI) (Deprecated)"}],"serializedName":"DPI","default":{"kind":"just","value":null},"name":"DPI","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Resolution"}],"serializedName":"resolution","default":{"kind":"just","value":null},"name":"resolution","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalResolution"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Color Space"}],"serializedName":"color","default":{"kind":"just","value":null},"name":"color","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalColorSpace"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Border"}],"serializedName":"border","default":{"kind":"just","value":null},"name":"border","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Border"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Sizes"}],"serializedName":"dataAmounts","default":{"kind":"just","value":null},"name":"dataAmounts","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmounts"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Formats\n"}],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Html5Formats"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Duration"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Duration of the animation\n"}],"serializedName":"durations","default":{"kind":"just","value":null},"name":"durations","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Durations"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Frame Rate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Frame rate\n"}],"serializedName":"frameRate","default":{"kind":"just","value":null},"name":"frameRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"FrameRate"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Looping"}],"serializedName":"loop","default":{"kind":"just","value":null},"name":"loop","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Number of loops"}],"serializedName":"loopCount","default":{"kind":"just","value":null},"name":"loopCount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Accepted 3rd party vendors"}],"serializedName":"accepted3rdPartyVendors","default":{"kind":"just","value":null},"name":"accepted3rdPartyVendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"Html5Media","version":{"kind":"nothing"}}};

export const snHtml5Media: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Html5Media"};

export function texprHtml5Media(): ADL.ATypeExpr<Html5Media> {
  return {value : {typeRef : {kind: "reference", value : snHtml5Media}, parameters : []}};
}

export interface FrameRate {
  value: number;
  unit: FrameRateUnit;
}

export function makeFrameRate(
  input: {
    value: number,
    unit: FrameRateUnit,
  }
): FrameRate {
  return {
    value: input.value,
    unit: input.unit,
  };
}

const FrameRate_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"FrameRateUnit"}},"parameters":[]}}]}},"name":"FrameRate","version":{"kind":"nothing"}}};

export const snFrameRate: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"FrameRate"};

export function texprFrameRate(): ADL.ATypeExpr<FrameRate> {
  return {value : {typeRef : {kind: "reference", value : snFrameRate}, parameters : []}};
}

export enum FrameRateUnit {
  perSecond,
}

const FrameRateUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"perSecond","default":{"kind":"nothing"},"name":"perSecond","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"FrameRateUnit","version":{"kind":"nothing"}}};

export const snFrameRateUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"FrameRateUnit"};

export function texprFrameRateUnit(): ADL.ATypeExpr<FrameRateUnit> {
  return {value : {typeRef : {kind: "reference", value : snFrameRateUnit}, parameters : []}};
}

export interface Video {
  dimensions: Annotated<DigitalMediaDimensions>;
  orientation: (Annotated<MediaOrientation>|null);
  aspectRatios: (Annotated<VideoAspectRatios>|null);
  safeZone: (Annotated<common.Unit>|null);
  durations: (Annotated<Durations>|null);
  /**
   * Supported container formats for video
   */
  formats: Annotated<VideoFormat>;
  codec: (Annotated<VideoCodec>|null);
  /**
   * Frame rate
   */
  frameRate: (Annotated<FrameRate>|null);
  profile: (Annotated<string>|null);
  profileLevel: (Annotated<string>|null);
  /**
   * Bit rate
   */
  bitrate: (Annotated<BitRate>|null);
  fieldRender: (Annotated<string>|null);
  loop: (Annotated<common.Unit>|null);
  loopCount: (Annotated<number>|null);
  audio: (Annotated<VideoAudioSupport>|null);
  subtitles: (Annotated<common.Unit>|null);
  script: (Annotated<VideoScriptSupport>|null);
  dataAmounts: (Annotated<DataAmounts>|null);
  maxFileSize: (Annotated<DataAmount>|null);
  accepted3rdPartyVendors: (Attributes|null);
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makeVideo(
  input: {
    dimensions: Annotated<DigitalMediaDimensions>,
    orientation?: (Annotated<MediaOrientation>|null),
    aspectRatios?: (Annotated<VideoAspectRatios>|null),
    safeZone?: (Annotated<common.Unit>|null),
    durations?: (Annotated<Durations>|null),
    formats: Annotated<VideoFormat>,
    codec?: (Annotated<VideoCodec>|null),
    frameRate?: (Annotated<FrameRate>|null),
    profile?: (Annotated<string>|null),
    profileLevel?: (Annotated<string>|null),
    bitrate?: (Annotated<BitRate>|null),
    fieldRender?: (Annotated<string>|null),
    loop?: (Annotated<common.Unit>|null),
    loopCount?: (Annotated<number>|null),
    audio?: (Annotated<VideoAudioSupport>|null),
    subtitles?: (Annotated<common.Unit>|null),
    script?: (Annotated<VideoScriptSupport>|null),
    dataAmounts?: (Annotated<DataAmounts>|null),
    maxFileSize?: (Annotated<DataAmount>|null),
    accepted3rdPartyVendors?: (Attributes|null),
    attributes?: Attributes,
  }
): Video {
  return {
    dimensions: input.dimensions,
    orientation: input.orientation === undefined ? null : input.orientation,
    aspectRatios: input.aspectRatios === undefined ? null : input.aspectRatios,
    safeZone: input.safeZone === undefined ? null : input.safeZone,
    durations: input.durations === undefined ? null : input.durations,
    formats: input.formats,
    codec: input.codec === undefined ? null : input.codec,
    frameRate: input.frameRate === undefined ? null : input.frameRate,
    profile: input.profile === undefined ? null : input.profile,
    profileLevel: input.profileLevel === undefined ? null : input.profileLevel,
    bitrate: input.bitrate === undefined ? null : input.bitrate,
    fieldRender: input.fieldRender === undefined ? null : input.fieldRender,
    loop: input.loop === undefined ? null : input.loop,
    loopCount: input.loopCount === undefined ? null : input.loopCount,
    audio: input.audio === undefined ? null : input.audio,
    subtitles: input.subtitles === undefined ? null : input.subtitles,
    script: input.script === undefined ? null : input.script,
    dataAmounts: input.dataAmounts === undefined ? null : input.dataAmounts,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    accepted3rdPartyVendors: input.accepted3rdPartyVendors === undefined ? null : input.accepted3rdPartyVendors,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const Video_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dimensions","default":{"kind":"nothing"},"name":"dimensions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DigitalMediaDimensions"}},"parameters":[]}]}},{"annotations":[],"serializedName":"orientation","default":{"kind":"just","value":null},"name":"orientation","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"MediaOrientation"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Aspect Ratio"}],"serializedName":"aspectRatios","default":{"kind":"just","value":null},"name":"aspectRatios","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoAspectRatios"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Safe Zone"}],"serializedName":"safeZone","default":{"kind":"just","value":null},"name":"safeZone","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Duration"}],"serializedName":"durations","default":{"kind":"just","value":null},"name":"durations","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Durations"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Format"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported container formats for video\n"}],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Codec"}],"serializedName":"codec","default":{"kind":"just","value":null},"name":"codec","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoCodec"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Frame Rate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Frame rate\n"}],"serializedName":"frameRate","default":{"kind":"just","value":null},"name":"frameRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"FrameRate"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Profile"}],"serializedName":"profile","default":{"kind":"just","value":null},"name":"profile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Profile Level"}],"serializedName":"profileLevel","default":{"kind":"just","value":null},"name":"profileLevel","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bitrate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bit rate\n"}],"serializedName":"bitrate","default":{"kind":"just","value":null},"name":"bitrate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"BitRate"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Field Render"}],"serializedName":"fieldRender","default":{"kind":"just","value":null},"name":"fieldRender","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Looping"}],"serializedName":"loop","default":{"kind":"just","value":null},"name":"loop","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Number of loops"}],"serializedName":"loopCount","default":{"kind":"just","value":null},"name":"loopCount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Audio support"}],"serializedName":"audio","default":{"kind":"just","value":null},"name":"audio","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoAudioSupport"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"subtitles","default":{"kind":"just","value":null},"name":"subtitles","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Video script support"}],"serializedName":"script","default":{"kind":"just","value":null},"name":"script","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoScriptSupport"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Sizes"}],"serializedName":"dataAmounts","default":{"kind":"just","value":null},"name":"dataAmounts","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmounts"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.http","name":"OpenApiExclude"},"v2":true},{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size (deprecated)"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Accepted 3rd party vendors"}],"serializedName":"accepted3rdPartyVendors","default":{"kind":"just","value":null},"name":"accepted3rdPartyVendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"Video","version":{"kind":"nothing"}}};

export const snVideo: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Video"};

export function texprVideo(): ADL.ATypeExpr<Video> {
  return {value : {typeRef : {kind: "reference", value : snVideo}, parameters : []}};
}

export interface VideoAspectRatios {
  square: (common.Unit|null);
  portrait_9_16: (common.Unit|null);
  landscape_16_9: (common.Unit|null);
  portrait_4_5: (common.Unit|null);
  custom: VectorAnnotated<CustomAspectRatio>;
  other: VectorAnnotated<string>;
}

export function makeVideoAspectRatios(
  input: {
    square?: (common.Unit|null),
    portrait_9_16?: (common.Unit|null),
    landscape_16_9?: (common.Unit|null),
    portrait_4_5?: (common.Unit|null),
    custom?: VectorAnnotated<CustomAspectRatio>,
    other?: VectorAnnotated<string>,
  }
): VideoAspectRatios {
  return {
    square: input.square === undefined ? null : input.square,
    portrait_9_16: input.portrait_9_16 === undefined ? null : input.portrait_9_16,
    landscape_16_9: input.landscape_16_9 === undefined ? null : input.landscape_16_9,
    portrait_4_5: input.portrait_4_5 === undefined ? null : input.portrait_4_5,
    custom: input.custom === undefined ? [] : input.custom,
    other: input.other === undefined ? [] : input.other,
  };
}

const VideoAspectRatios_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Square (1:1)"}],"serializedName":"square","default":{"kind":"just","value":null},"name":"square","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Portrait (9:16)"}],"serializedName":"portrait_9_16","default":{"kind":"just","value":null},"name":"portrait_9_16","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Landscape (16:9)"}],"serializedName":"landscape_16_9","default":{"kind":"just","value":null},"name":"landscape_16_9","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Portrait (4:5)"}],"serializedName":"portrait_4_5","default":{"kind":"just","value":null},"name":"portrait_4_5","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Custom"}],"serializedName":"custom","default":{"kind":"just","value":[]},"name":"custom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"CustomAspectRatio"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Other"}],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"VideoAspectRatios","version":{"kind":"nothing"}}};

export const snVideoAspectRatios: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VideoAspectRatios"};

export function texprVideoAspectRatios(): ADL.ATypeExpr<VideoAspectRatios> {
  return {value : {typeRef : {kind: "reference", value : snVideoAspectRatios}, parameters : []}};
}

export interface CustomAspectRatio {
  name: string;
  width: number;
  height: number;
}

export function makeCustomAspectRatio(
  input: {
    name: string,
    width: number,
    height: number,
  }
): CustomAspectRatio {
  return {
    name: input.name,
    width: input.width,
    height: input.height,
  };
}

const CustomAspectRatio_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"width","default":{"kind":"nothing"},"name":"width","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"height","default":{"kind":"nothing"},"name":"height","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"CustomAspectRatio","version":{"kind":"nothing"}}};

export const snCustomAspectRatio: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"CustomAspectRatio"};

export function texprCustomAspectRatio(): ADL.ATypeExpr<CustomAspectRatio> {
  return {value : {typeRef : {kind: "reference", value : snCustomAspectRatio}, parameters : []}};
}

export interface BitRate {
  value: number;
  unit: BitRateUnit;
}

export function makeBitRate(
  input: {
    value: number,
    unit: BitRateUnit,
  }
): BitRate {
  return {
    value: input.value,
    unit: input.unit,
  };
}

const BitRate_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"BitRateUnit"}},"parameters":[]}}]}},"name":"BitRate","version":{"kind":"nothing"}}};

export const snBitRate: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"BitRate"};

export function texprBitRate(): ADL.ATypeExpr<BitRate> {
  return {value : {typeRef : {kind: "reference", value : snBitRate}, parameters : []}};
}

export enum BitRateUnit {
  Mbps,
  Kbps,
}

const BitRateUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Mbps","default":{"kind":"nothing"},"name":"Mbps","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Kbps","default":{"kind":"nothing"},"name":"Kbps","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"BitRateUnit","version":{"kind":"nothing"}}};

export const snBitRateUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"BitRateUnit"};

export function texprBitRateUnit(): ADL.ATypeExpr<BitRateUnit> {
  return {value : {typeRef : {kind: "reference", value : snBitRateUnit}, parameters : []}};
}

export interface VideoAudioSupport {
  /**
   * Supported audio formats
   */
  formats: Annotated<AudioFormat>;
  /**
   * Decibel notes
   */
  decibels: (Annotated<string>|null);
  /**
   * Audio Bit rate
   */
  audioBitrate: (Annotated<BitRate>|null);
  /**
   * Sample rate
   */
  sampleRate: (Annotated<SampleRate>|null);
}

export function makeVideoAudioSupport(
  input: {
    formats: Annotated<AudioFormat>,
    decibels?: (Annotated<string>|null),
    audioBitrate?: (Annotated<BitRate>|null),
    sampleRate?: (Annotated<SampleRate>|null),
  }
): VideoAudioSupport {
  return {
    formats: input.formats,
    decibels: input.decibels === undefined ? null : input.decibels,
    audioBitrate: input.audioBitrate === undefined ? null : input.audioBitrate,
    sampleRate: input.sampleRate === undefined ? null : input.sampleRate,
  };
}

const VideoAudioSupport_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Formats"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported audio formats\n"}],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AudioFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Loudness"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Decibel notes\n"}],"serializedName":"decibels","default":{"kind":"just","value":null},"name":"decibels","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Audio Bitrate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Audio Bit rate\n"}],"serializedName":"audioBitrate","default":{"kind":"just","value":null},"name":"audioBitrate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"BitRate"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Sample Rate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Sample rate\n"}],"serializedName":"sampleRate","default":{"kind":"just","value":null},"name":"sampleRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"SampleRate"}},"parameters":[]}]}]}}]}},"name":"VideoAudioSupport","version":{"kind":"nothing"}}};

export const snVideoAudioSupport: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VideoAudioSupport"};

export function texprVideoAudioSupport(): ADL.ATypeExpr<VideoAudioSupport> {
  return {value : {typeRef : {kind: "reference", value : snVideoAudioSupport}, parameters : []}};
}

export interface VideoScriptSupport {
  /**
   * Supported video scripts
   */
  scriptFormat: VideoScriptFormat;
}

export function makeVideoScriptSupport(
  input: {
    scriptFormat: VideoScriptFormat,
  }
): VideoScriptSupport {
  return {
    scriptFormat: input.scriptFormat,
  };
}

const VideoScriptSupport_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Supported video scripts"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported video scripts\n"}],"serializedName":"scriptFormat","default":{"kind":"nothing"},"name":"scriptFormat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VideoScriptFormat"}},"parameters":[]}}]}},"name":"VideoScriptSupport","version":{"kind":"nothing"}}};

export const snVideoScriptSupport: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VideoScriptSupport"};

export function texprVideoScriptSupport(): ADL.ATypeExpr<VideoScriptSupport> {
  return {value : {typeRef : {kind: "reference", value : snVideoScriptSupport}, parameters : []}};
}

/**
 * Audio
 */
export interface Audio {
  /**
   * Duration of the audio
   */
  durations: Annotated<Durations>;
  /**
   * Supported audio formats
   */
  formats: Annotated<AudioFormat>;
  codecs: (Annotated<AudioCodecs>|null);
  /**
   * Bit rate
   */
  bitrate: (Annotated<BitRate>|null);
  /**
   * Bit rate
   */
  sampleRate: (Annotated<SampleRate>|null);
  /**
   * Decibel notes
   */
  decibels: (Annotated<string>|null);
  maxFileSize: (Annotated<DataAmount>|null);
  adServing: (Annotated<string>|null);
  tracking: (Annotated<string>|null);
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makeAudio(
  input: {
    durations: Annotated<Durations>,
    formats: Annotated<AudioFormat>,
    codecs?: (Annotated<AudioCodecs>|null),
    bitrate?: (Annotated<BitRate>|null),
    sampleRate?: (Annotated<SampleRate>|null),
    decibels?: (Annotated<string>|null),
    maxFileSize?: (Annotated<DataAmount>|null),
    adServing?: (Annotated<string>|null),
    tracking?: (Annotated<string>|null),
    attributes?: Attributes,
  }
): Audio {
  return {
    durations: input.durations,
    formats: input.formats,
    codecs: input.codecs === undefined ? null : input.codecs,
    bitrate: input.bitrate === undefined ? null : input.bitrate,
    sampleRate: input.sampleRate === undefined ? null : input.sampleRate,
    decibels: input.decibels === undefined ? null : input.decibels,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
    adServing: input.adServing === undefined ? null : input.adServing,
    tracking: input.tracking === undefined ? null : input.tracking,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const Audio_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Audio\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Duration"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Duration of the audio\n"}],"serializedName":"durations","default":{"kind":"nothing"},"name":"durations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Durations"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Formats"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supported audio formats\n"}],"serializedName":"formats","default":{"kind":"nothing"},"name":"formats","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AudioFormat"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Codecs"}],"serializedName":"codecs","default":{"kind":"just","value":null},"name":"codecs","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"AudioCodecs"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Bitrate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bit rate\n"}],"serializedName":"bitrate","default":{"kind":"just","value":null},"name":"bitrate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"BitRate"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Sample Rate"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bit rate\n"}],"serializedName":"sampleRate","default":{"kind":"just","value":null},"name":"sampleRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"SampleRate"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Loudness"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Decibel notes\n"}],"serializedName":"decibels","default":{"kind":"just","value":null},"name":"decibels","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Max File Size"}],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Ad Serving"}],"serializedName":"adServing","default":{"kind":"just","value":null},"name":"adServing","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Tracking"}],"serializedName":"tracking","default":{"kind":"just","value":null},"name":"tracking","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"Audio","version":{"kind":"nothing"}}};

export const snAudio: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Audio"};

export function texprAudio(): ADL.ATypeExpr<Audio> {
  return {value : {typeRef : {kind: "reference", value : snAudio}, parameters : []}};
}

export type AudioCodecs = VectorNamedAnnotated<string>;

const AudioCodecs_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorNamedAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}},"name":"AudioCodecs","version":{"kind":"nothing"}}};

export const snAudioCodecs: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AudioCodecs"};

export function texprAudioCodecs(): ADL.ATypeExpr<AudioCodecs> {
  return {value : {typeRef : {kind: "reference", value : snAudioCodecs}, parameters : []}};
}

export interface SampleRate {
  value: number;
  unit: SampleRateUnit;
}

export function makeSampleRate(
  input: {
    value: number,
    unit: SampleRateUnit,
  }
): SampleRate {
  return {
    value: input.value,
    unit: input.unit,
  };
}

const SampleRate_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"SampleRateUnit"}},"parameters":[]}}]}},"name":"SampleRate","version":{"kind":"nothing"}}};

export const snSampleRate: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"SampleRate"};

export function texprSampleRate(): ADL.ATypeExpr<SampleRate> {
  return {value : {typeRef : {kind: "reference", value : snSampleRate}, parameters : []}};
}

export enum SampleRateUnit {
  kiloHertz,
}

const SampleRateUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"kiloHertz","default":{"kind":"nothing"},"name":"kiloHertz","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SampleRateUnit","version":{"kind":"nothing"}}};

export const snSampleRateUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"SampleRateUnit"};

export function texprSampleRateUnit(): ADL.ATypeExpr<SampleRateUnit> {
  return {value : {typeRef : {kind: "reference", value : snSampleRateUnit}, parameters : []}};
}

/**
 * Media Orientation
 */
export interface MediaOrientation {
  landscape: (common.Unit|null);
  portrait: (common.Unit|null);
  square: (common.Unit|null);
  other: VectorAnnotated<string>;
}

export function makeMediaOrientation(
  input: {
    landscape?: (common.Unit|null),
    portrait?: (common.Unit|null),
    square?: (common.Unit|null),
    other?: VectorAnnotated<string>,
  }
): MediaOrientation {
  return {
    landscape: input.landscape === undefined ? null : input.landscape,
    portrait: input.portrait === undefined ? null : input.portrait,
    square: input.square === undefined ? null : input.square,
    other: input.other === undefined ? [] : input.other,
  };
}

const MediaOrientation_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Media Orientation\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Landscape"}],"serializedName":"landscape","default":{"kind":"just","value":null},"name":"landscape","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Portrait"}],"serializedName":"portrait","default":{"kind":"just","value":null},"name":"portrait","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Square"}],"serializedName":"square","default":{"kind":"just","value":null},"name":"square","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Other"}],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"MediaOrientation","version":{"kind":"nothing"}}};

export const snMediaOrientation: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"MediaOrientation"};

export function texprMediaOrientation(): ADL.ATypeExpr<MediaOrientation> {
  return {value : {typeRef : {kind: "reference", value : snMediaOrientation}, parameters : []}};
}

/**
 * See also VideoAspectRatios
 * Video Script format
 */
export interface VideoScriptFormat {
  VAST: (common.Unit|null);
  VPAID: (common.Unit|null);
}

export function makeVideoScriptFormat(
  input: {
    VAST?: (common.Unit|null),
    VPAID?: (common.Unit|null),
  }
): VideoScriptFormat {
  return {
    VAST: input.VAST === undefined ? null : input.VAST,
    VPAID: input.VPAID === undefined ? null : input.VPAID,
  };
}

const VideoScriptFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"See also VideoAspectRatios\nVideo Script format\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"VAST TAG"}],"serializedName":"VAST","default":{"kind":"just","value":null},"name":"VAST","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"VPAID"}],"serializedName":"VPAID","default":{"kind":"just","value":null},"name":"VPAID","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"VideoScriptFormat","version":{"kind":"nothing"}}};

export const snVideoScriptFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VideoScriptFormat"};

export function texprVideoScriptFormat(): ADL.ATypeExpr<VideoScriptFormat> {
  return {value : {typeRef : {kind: "reference", value : snVideoScriptFormat}, parameters : []}};
}

/**
 * Video format
 */
export interface VideoFormat {
  MP4: (common.Unit|null);
  WebM: (common.Unit|null);
  MOV: (common.Unit|null);
  WMV: (common.Unit|null);
  AVI: (common.Unit|null);
  OGG: (common.Unit|null);
  ThreeGP: (common.Unit|null);
  FLV: (common.Unit|null);
  other: VectorAnnotated<string>;
}

export function makeVideoFormat(
  input: {
    MP4?: (common.Unit|null),
    WebM?: (common.Unit|null),
    MOV?: (common.Unit|null),
    WMV?: (common.Unit|null),
    AVI?: (common.Unit|null),
    OGG?: (common.Unit|null),
    ThreeGP?: (common.Unit|null),
    FLV?: (common.Unit|null),
    other?: VectorAnnotated<string>,
  }
): VideoFormat {
  return {
    MP4: input.MP4 === undefined ? null : input.MP4,
    WebM: input.WebM === undefined ? null : input.WebM,
    MOV: input.MOV === undefined ? null : input.MOV,
    WMV: input.WMV === undefined ? null : input.WMV,
    AVI: input.AVI === undefined ? null : input.AVI,
    OGG: input.OGG === undefined ? null : input.OGG,
    ThreeGP: input.ThreeGP === undefined ? null : input.ThreeGP,
    FLV: input.FLV === undefined ? null : input.FLV,
    other: input.other === undefined ? [] : input.other,
  };
}

const VideoFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Video format\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"MP4","default":{"kind":"just","value":null},"name":"MP4","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"WebM","default":{"kind":"just","value":null},"name":"WebM","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"MOV","default":{"kind":"just","value":null},"name":"MOV","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"WMV","default":{"kind":"just","value":null},"name":"WMV","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"AVI","default":{"kind":"just","value":null},"name":"AVI","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"OGG","default":{"kind":"just","value":null},"name":"OGG","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"3GP"}],"serializedName":"ThreeGP","default":{"kind":"just","value":null},"name":"ThreeGP","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"FLV","default":{"kind":"just","value":null},"name":"FLV","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"VideoFormat","version":{"kind":"nothing"}}};

export const snVideoFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VideoFormat"};

export function texprVideoFormat(): ADL.ATypeExpr<VideoFormat> {
  return {value : {typeRef : {kind: "reference", value : snVideoFormat}, parameters : []}};
}

/**
 * Video codec
 */
export interface VideoCodec {
  avc_h264: (common.Unit|null);
  hevc_h265: (common.Unit|null);
  mpeg2: (common.Unit|null);
  mpeg4: (common.Unit|null);
  divx: (common.Unit|null);
  Webm_vp9: (common.Unit|null);
  Webm_vp8: (common.Unit|null);
  ProRes422: (common.Unit|null);
  QuickTime: (common.Unit|null);
  other: VectorAnnotated<string>;
}

export function makeVideoCodec(
  input: {
    avc_h264?: (common.Unit|null),
    hevc_h265?: (common.Unit|null),
    mpeg2?: (common.Unit|null),
    mpeg4?: (common.Unit|null),
    divx?: (common.Unit|null),
    Webm_vp9?: (common.Unit|null),
    Webm_vp8?: (common.Unit|null),
    ProRes422?: (common.Unit|null),
    QuickTime?: (common.Unit|null),
    other?: VectorAnnotated<string>,
  }
): VideoCodec {
  return {
    avc_h264: input.avc_h264 === undefined ? null : input.avc_h264,
    hevc_h265: input.hevc_h265 === undefined ? null : input.hevc_h265,
    mpeg2: input.mpeg2 === undefined ? null : input.mpeg2,
    mpeg4: input.mpeg4 === undefined ? null : input.mpeg4,
    divx: input.divx === undefined ? null : input.divx,
    Webm_vp9: input.Webm_vp9 === undefined ? null : input.Webm_vp9,
    Webm_vp8: input.Webm_vp8 === undefined ? null : input.Webm_vp8,
    ProRes422: input.ProRes422 === undefined ? null : input.ProRes422,
    QuickTime: input.QuickTime === undefined ? null : input.QuickTime,
    other: input.other === undefined ? [] : input.other,
  };
}

const VideoCodec_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Video codec\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"AVC (h264)"}],"serializedName":"avc_h264","default":{"kind":"just","value":null},"name":"avc_h264","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"HEVC (h265)"}],"serializedName":"hevc_h265","default":{"kind":"just","value":null},"name":"hevc_h265","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"MPEG-2"}],"serializedName":"mpeg2","default":{"kind":"just","value":null},"name":"mpeg2","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"MPEG-4"}],"serializedName":"mpeg4","default":{"kind":"just","value":null},"name":"mpeg4","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"DivX"}],"serializedName":"divx","default":{"kind":"just","value":null},"name":"divx","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"WebM VP9"}],"serializedName":"Webm_vp9","default":{"kind":"just","value":null},"name":"Webm_vp9","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"WebM VP8"}],"serializedName":"Webm_vp8","default":{"kind":"just","value":null},"name":"Webm_vp8","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Pro Res 422"}],"serializedName":"ProRes422","default":{"kind":"just","value":null},"name":"ProRes422","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"QuickTime"}],"serializedName":"QuickTime","default":{"kind":"just","value":null},"name":"QuickTime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"VideoCodec","version":{"kind":"nothing"}}};

export const snVideoCodec: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"VideoCodec"};

export function texprVideoCodec(): ADL.ATypeExpr<VideoCodec> {
  return {value : {typeRef : {kind: "reference", value : snVideoCodec}, parameters : []}};
}

/**
 * Audio format
 */
export interface AudioFormat {
  WAV: (common.Unit|null);
  AIFF: (common.Unit|null);
  MP3: (common.Unit|null);
  AAC: (common.Unit|null);
  other: VectorAnnotated<string>;
}

export function makeAudioFormat(
  input: {
    WAV?: (common.Unit|null),
    AIFF?: (common.Unit|null),
    MP3?: (common.Unit|null),
    AAC?: (common.Unit|null),
    other?: VectorAnnotated<string>,
  }
): AudioFormat {
  return {
    WAV: input.WAV === undefined ? null : input.WAV,
    AIFF: input.AIFF === undefined ? null : input.AIFF,
    MP3: input.MP3 === undefined ? null : input.MP3,
    AAC: input.AAC === undefined ? null : input.AAC,
    other: input.other === undefined ? [] : input.other,
  };
}

const AudioFormat_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Audio format\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"WAV","default":{"kind":"just","value":null},"name":"WAV","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"AIFF","default":{"kind":"just","value":null},"name":"AIFF","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"MP3","default":{"kind":"just","value":null},"name":"MP3","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"AAC","default":{"kind":"just","value":null},"name":"AAC","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"other","default":{"kind":"just","value":[]},"name":"other","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorAnnotated"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"AudioFormat","version":{"kind":"nothing"}}};

export const snAudioFormat: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"AudioFormat"};

export function texprAudioFormat(): ADL.ATypeExpr<AudioFormat> {
  return {value : {typeRef : {kind: "reference", value : snAudioFormat}, parameters : []}};
}

/**
 * Color spaces
 */
export interface DigitalColorSpace {
  RGB: (common.Unit|null);
  HEX: (common.Unit|null);
}

export function makeDigitalColorSpace(
  input: {
    RGB?: (common.Unit|null),
    HEX?: (common.Unit|null),
  }
): DigitalColorSpace {
  return {
    RGB: input.RGB === undefined ? null : input.RGB,
    HEX: input.HEX === undefined ? null : input.HEX,
  };
}

const DigitalColorSpace_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Color spaces\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"RGB","default":{"kind":"just","value":null},"name":"RGB","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"HEX","default":{"kind":"just","value":null},"name":"HEX","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"DigitalColorSpace","version":{"kind":"nothing"}}};

export const snDigitalColorSpace: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DigitalColorSpace"};

export function texprDigitalColorSpace(): ADL.ATypeExpr<DigitalColorSpace> {
  return {value : {typeRef : {kind: "reference", value : snDigitalColorSpace}, parameters : []}};
}

/**
 * Color spaces
 */
export interface RGBOnlyColorSpace {
  RGB: (common.Unit|null);
}

export function makeRGBOnlyColorSpace(
  input: {
    RGB?: (common.Unit|null),
  }
): RGBOnlyColorSpace {
  return {
    RGB: input.RGB === undefined ? null : input.RGB,
  };
}

const RGBOnlyColorSpace_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Color spaces\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"RGB","default":{"kind":"just","value":null},"name":"RGB","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}]}},"name":"RGBOnlyColorSpace","version":{"kind":"nothing"}}};

export const snRGBOnlyColorSpace: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"RGBOnlyColorSpace"};

export function texprRGBOnlyColorSpace(): ADL.ATypeExpr<RGBOnlyColorSpace> {
  return {value : {typeRef : {kind: "reference", value : snRGBOnlyColorSpace}, parameters : []}};
}

/**
 * Amount of data / file size
 */
export interface DataAmount {
  amount: number;
  unit: FileSizeUnit;
}

export function makeDataAmount(
  input: {
    amount: number,
    unit: FileSizeUnit,
  }
): DataAmount {
  return {
    amount: input.amount,
    unit: input.unit,
  };
}

const DataAmount_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Amount of data / file size\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"unit","default":{"kind":"nothing"},"name":"unit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"FileSizeUnit"}},"parameters":[]}}]}},"name":"DataAmount","version":{"kind":"nothing"}}};

export const snDataAmount: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"DataAmount"};

export function texprDataAmount(): ADL.ATypeExpr<DataAmount> {
  return {value : {typeRef : {kind: "reference", value : snDataAmount}, parameters : []}};
}

export enum FileSizeUnit {
  kb,
  mb,
  gb,
}

const FileSizeUnit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Kilobytes\n"}],"serializedName":"kb","default":{"kind":"nothing"},"name":"kb","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Megabytes\n"}],"serializedName":"mb","default":{"kind":"nothing"},"name":"mb","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gigabytes\n"}],"serializedName":"gb","default":{"kind":"nothing"},"name":"gb","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"FileSizeUnit","version":{"kind":"nothing"}}};

export const snFileSizeUnit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"FileSizeUnit"};

export function texprFileSizeUnit(): ADL.ATypeExpr<FileSizeUnit> {
  return {value : {typeRef : {kind: "reference", value : snFileSizeUnit}, parameters : []}};
}

/**
 * Listing of string properties in a flat list.
 */
export type Attributes = KeyValueAttribute[];

const Attributes_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Listing of string properties in a flat list.\n"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"KeyValueAttribute"}},"parameters":[]}]}}},"name":"Attributes","version":{"kind":"nothing"}}};

export const snAttributes: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"Attributes"};

export function texprAttributes(): ADL.ATypeExpr<Attributes> {
  return {value : {typeRef : {kind: "reference", value : snAttributes}, parameters : []}};
}

export interface KeyValueAttribute {
  name: string;
  value: kachemedia_specsheet_common.Notes;
  metadata: (Metadata|null);
}

export function makeKeyValueAttribute(
  input: {
    name: string,
    value: kachemedia_specsheet_common.Notes,
    metadata?: (Metadata|null),
  }
): KeyValueAttribute {
  return {
    name: input.name,
    value: input.value,
    metadata: input.metadata === undefined ? null : input.metadata,
  };
}

const KeyValueAttribute_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Notes"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Add notes and images"}],"serializedName":"metadata","default":{"kind":"just","value":null},"name":"metadata","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Metadata"}},"parameters":[]}]}}]}},"name":"KeyValueAttribute","version":{"kind":"nothing"}}};

export const snKeyValueAttribute: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"KeyValueAttribute"};

export function texprKeyValueAttribute(): ADL.ATypeExpr<KeyValueAttribute> {
  return {value : {typeRef : {kind: "reference", value : snKeyValueAttribute}, parameters : []}};
}

export interface CopyMedia {
  text: Annotated<CopyMediaTextSpecs>;
  /**
   * Untyped general notes / properties
   */
  attributes: Attributes;
}

export function makeCopyMedia(
  input: {
    text: Annotated<CopyMediaTextSpecs>,
    attributes?: Attributes,
  }
): CopyMedia {
  return {
    text: input.text,
    attributes: input.attributes === undefined ? [] : input.attributes,
  };
}

const CopyMedia_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"text","default":{"kind":"nothing"},"name":"text","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Annotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"CopyMediaTextSpecs"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}}]}},"name":"CopyMedia","version":{"kind":"nothing"}}};

export const snCopyMedia: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"CopyMedia"};

export function texprCopyMedia(): ADL.ATypeExpr<CopyMedia> {
  return {value : {typeRef : {kind: "reference", value : snCopyMedia}, parameters : []}};
}

export type CopyMediaTextSpecs = VectorNamedAnnotated<CopyMediaTextSpec>;

const CopyMediaTextSpecs_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"VectorNamedAnnotated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"CopyMediaTextSpec"}},"parameters":[]}]}}},"name":"CopyMediaTextSpecs","version":{"kind":"nothing"}}};

export const snCopyMediaTextSpecs: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"CopyMediaTextSpecs"};

export function texprCopyMediaTextSpecs(): ADL.ATypeExpr<CopyMediaTextSpecs> {
  return {value : {typeRef : {kind: "reference", value : snCopyMediaTextSpecs}, parameters : []}};
}

export interface CopyMediaTextSpec {
  minCharacters: (number|null);
  maxCharacters: (number|null);
  maxFileSize: (DataAmount|null);
}

export function makeCopyMediaTextSpec(
  input: {
    minCharacters?: (number|null),
    maxCharacters?: (number|null),
    maxFileSize?: (DataAmount|null),
  }
): CopyMediaTextSpec {
  return {
    minCharacters: input.minCharacters === undefined ? null : input.minCharacters,
    maxCharacters: input.maxCharacters === undefined ? null : input.maxCharacters,
    maxFileSize: input.maxFileSize === undefined ? null : input.maxFileSize,
  };
}

const CopyMediaTextSpec_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.artworkspec","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"minCharacters","default":{"kind":"just","value":null},"name":"minCharacters","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Word64"},"parameters":[]}]}},{"annotations":[],"serializedName":"maxCharacters","default":{"kind":"just","value":null},"name":"maxCharacters","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Word64"},"parameters":[]}]}},{"annotations":[],"serializedName":"maxFileSize","default":{"kind":"just","value":null},"name":"maxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"DataAmount"}},"parameters":[]}]}}]}},"name":"CopyMediaTextSpec","version":{"kind":"nothing"}}};

export const snCopyMediaTextSpec: ADL.ScopedName = {moduleName:"kachemedia.specsheet.artworkspec", name:"CopyMediaTextSpec"};

export function texprCopyMediaTextSpec(): ADL.ATypeExpr<CopyMediaTextSpec> {
  return {value : {typeRef : {kind: "reference", value : snCopyMediaTextSpec}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.artworkspec.Specifications" : Specifications_AST,
  "kachemedia.specsheet.artworkspec.VectorNamedAnnotated" : VectorNamedAnnotated_AST,
  "kachemedia.specsheet.artworkspec.VectorAnnotated" : VectorAnnotated_AST,
  "kachemedia.specsheet.artworkspec.ArtworkSpec" : ArtworkSpec_AST,
  "kachemedia.specsheet.artworkspec.Annotated" : Annotated_AST,
  "kachemedia.specsheet.artworkspec.NamedAnnotated" : NamedAnnotated_AST,
  "kachemedia.specsheet.artworkspec.Metadata" : Metadata_AST,
  "kachemedia.specsheet.artworkspec.AuthorNotes" : AuthorNotes_AST,
  "kachemedia.specsheet.artworkspec.AuthorNotesReason" : AuthorNotesReason_AST,
  "kachemedia.specsheet.artworkspec.PrintResolution" : PrintResolution_AST,
  "kachemedia.specsheet.artworkspec.PrintResolutionUnit" : PrintResolutionUnit_AST,
  "kachemedia.specsheet.artworkspec.DigitalResolution" : DigitalResolution_AST,
  "kachemedia.specsheet.artworkspec.DigitalResolutionUnit" : DigitalResolutionUnit_AST,
  "kachemedia.specsheet.artworkspec.DigitalStaticMedia" : DigitalStaticMedia_AST,
  "kachemedia.specsheet.artworkspec.AdditionalPrintDimensions" : AdditionalPrintDimensions_AST,
  "kachemedia.specsheet.artworkspec.PrintDimension" : PrintDimension_AST,
  "kachemedia.specsheet.artworkspec.PrintDimensions" : PrintDimensions_AST,
  "kachemedia.specsheet.artworkspec.PrintBorderDimensions" : PrintBorderDimensions_AST,
  "kachemedia.specsheet.artworkspec.PrintMediaFormat" : PrintMediaFormat_AST,
  "kachemedia.specsheet.artworkspec.PrintNewspaper" : PrintNewspaper_AST,
  "kachemedia.specsheet.artworkspec.PrintMagazine" : PrintMagazine_AST,
  "kachemedia.specsheet.artworkspec.PrintDimensionOptions" : PrintDimensionOptions_AST,
  "kachemedia.specsheet.artworkspec.Frontlit" : Frontlit_AST,
  "kachemedia.specsheet.artworkspec.Backlit" : Backlit_AST,
  "kachemedia.specsheet.artworkspec.FrontlitTop" : FrontlitTop_AST,
  "kachemedia.specsheet.artworkspec.FrontlitBottom" : FrontlitBottom_AST,
  "kachemedia.specsheet.artworkspec.Illumination" : Illumination_AST,
  "kachemedia.specsheet.artworkspec.DimensionUnit" : DimensionUnit_AST,
  "kachemedia.specsheet.artworkspec.PrintOOH" : PrintOOH_AST,
  "kachemedia.specsheet.artworkspec.PixelDimension" : PixelDimension_AST,
  "kachemedia.specsheet.artworkspec.DigitalMediaDimensions" : DigitalMediaDimensions_AST,
  "kachemedia.specsheet.artworkspec.DigitalMediaDimension" : DigitalMediaDimension_AST,
  "kachemedia.specsheet.artworkspec.DimensionResolutionType" : DimensionResolutionType_AST,
  "kachemedia.specsheet.artworkspec.DimensionSizeCase" : DimensionSizeCase_AST,
  "kachemedia.specsheet.artworkspec.StaticMediaFormat" : StaticMediaFormat_AST,
  "kachemedia.specsheet.artworkspec.JPG" : JPG_AST,
  "kachemedia.specsheet.artworkspec.BMP" : BMP_AST,
  "kachemedia.specsheet.artworkspec.SVG" : SVG_AST,
  "kachemedia.specsheet.artworkspec.GIF" : GIF_AST,
  "kachemedia.specsheet.artworkspec.PDF" : PDF_AST,
  "kachemedia.specsheet.artworkspec.INDD" : INDD_AST,
  "kachemedia.specsheet.artworkspec.QuarkXPress" : QuarkXPress_AST,
  "kachemedia.specsheet.artworkspec.PNG" : PNG_AST,
  "kachemedia.specsheet.artworkspec.PNGFormat" : PNGFormat_AST,
  "kachemedia.specsheet.artworkspec.EPS" : EPS_AST,
  "kachemedia.specsheet.artworkspec.AI" : AI_AST,
  "kachemedia.specsheet.artworkspec.TIFF" : TIFF_AST,
  "kachemedia.specsheet.artworkspec.PSD" : PSD_AST,
  "kachemedia.specsheet.artworkspec.AnyFormatDetails" : AnyFormatDetails_AST,
  "kachemedia.specsheet.artworkspec.DataAmounts" : DataAmounts_AST,
  "kachemedia.specsheet.artworkspec.DataAmountProperty" : DataAmountProperty_AST,
  "kachemedia.specsheet.artworkspec.DataAmountType" : DataAmountType_AST,
  "kachemedia.specsheet.artworkspec.AnimatedMedia" : AnimatedMedia_AST,
  "kachemedia.specsheet.artworkspec.Border" : Border_AST,
  "kachemedia.specsheet.artworkspec.Durations" : Durations_AST,
  "kachemedia.specsheet.artworkspec.Duration" : Duration_AST,
  "kachemedia.specsheet.artworkspec.AnimatedMediaFormat" : AnimatedMediaFormat_AST,
  "kachemedia.specsheet.artworkspec.Html5Formats" : Html5Formats_AST,
  "kachemedia.specsheet.artworkspec.WebMediaFormat" : WebMediaFormat_AST,
  "kachemedia.specsheet.artworkspec.Html5Video" : Html5Video_AST,
  "kachemedia.specsheet.artworkspec.Html5Media" : Html5Media_AST,
  "kachemedia.specsheet.artworkspec.FrameRate" : FrameRate_AST,
  "kachemedia.specsheet.artworkspec.FrameRateUnit" : FrameRateUnit_AST,
  "kachemedia.specsheet.artworkspec.Video" : Video_AST,
  "kachemedia.specsheet.artworkspec.VideoAspectRatios" : VideoAspectRatios_AST,
  "kachemedia.specsheet.artworkspec.CustomAspectRatio" : CustomAspectRatio_AST,
  "kachemedia.specsheet.artworkspec.BitRate" : BitRate_AST,
  "kachemedia.specsheet.artworkspec.BitRateUnit" : BitRateUnit_AST,
  "kachemedia.specsheet.artworkspec.VideoAudioSupport" : VideoAudioSupport_AST,
  "kachemedia.specsheet.artworkspec.VideoScriptSupport" : VideoScriptSupport_AST,
  "kachemedia.specsheet.artworkspec.Audio" : Audio_AST,
  "kachemedia.specsheet.artworkspec.AudioCodecs" : AudioCodecs_AST,
  "kachemedia.specsheet.artworkspec.SampleRate" : SampleRate_AST,
  "kachemedia.specsheet.artworkspec.SampleRateUnit" : SampleRateUnit_AST,
  "kachemedia.specsheet.artworkspec.MediaOrientation" : MediaOrientation_AST,
  "kachemedia.specsheet.artworkspec.VideoScriptFormat" : VideoScriptFormat_AST,
  "kachemedia.specsheet.artworkspec.VideoFormat" : VideoFormat_AST,
  "kachemedia.specsheet.artworkspec.VideoCodec" : VideoCodec_AST,
  "kachemedia.specsheet.artworkspec.AudioFormat" : AudioFormat_AST,
  "kachemedia.specsheet.artworkspec.DigitalColorSpace" : DigitalColorSpace_AST,
  "kachemedia.specsheet.artworkspec.RGBOnlyColorSpace" : RGBOnlyColorSpace_AST,
  "kachemedia.specsheet.artworkspec.DataAmount" : DataAmount_AST,
  "kachemedia.specsheet.artworkspec.FileSizeUnit" : FileSizeUnit_AST,
  "kachemedia.specsheet.artworkspec.Attributes" : Attributes_AST,
  "kachemedia.specsheet.artworkspec.KeyValueAttribute" : KeyValueAttribute_AST,
  "kachemedia.specsheet.artworkspec.CopyMedia" : CopyMedia_AST,
  "kachemedia.specsheet.artworkspec.CopyMediaTextSpecs" : CopyMediaTextSpecs_AST,
  "kachemedia.specsheet.artworkspec.CopyMediaTextSpec" : CopyMediaTextSpec_AST
};
